// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:40:58.151Z
// Property: Boulders Lakeside (ID: 5722559043600384)
// Collections: 17 amenities, 6 floorplans (live), 37 photos, 82 POIs, 2 reviews, 1 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5722559043600384",
  "property_external_id": "4909372",
  "property_zillow_url": "https://www.zillow.com/b/boulders-lakeside-apartments-richmond-va-Bkn59w/",
  "property_apartments_url": "https://www.apartments.com/boulders-lakeside-north-chesterfield-va/801ngq2",
  "property_google_business_url": "https://www.google.com/maps/place/Boulders+Lakeside/@37.511572,-77.530467,15z/data=!4m5!3m4!1s0x0:0x95387231c8de76b6!8m2!3d37.511572!4d-77.530467",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443201068",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "boulders-lakeside",
  "property_name": "Boulders Lakeside",
  "property_website_url": "https://www.bouldersalapts.com/",
  "property_domain": "https://www.bouldersalapts.com/",
  "property_address": "1006 Boulder Lake Ter",
  "property_full_address": "1006 Boulder Lake Ter, North Chesterfield, VA 23225",
  "property_address_1": "1006 Boulder Lake Ter",
  "property_address_2": null,
  "property_address_city": "North Chesterfield",
  "property_address_state": "VA",
  "property_address_zip_full": "23225-5568",
  "property_address_zip": "23225",
  "property_address_country": "US",
  "property_address_county": "Chesterfield County",
  "property_neighborhood_address": "North Chesterfield",
  "property_address_latitude": "37.5115802",
  "property_address_longitude": "-77.53253099999999",
  "property_email": "boulders@alapts.com",
  "property_phone": "(804) 447-4008",
  "property_call_tracking_phone": "804-294-4342",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern lakeside living, minutes from Richmond.</strong> Discover polished one- and two-bedroom apartments with chef-inspired kitchens, hard-surface flooring, generous storage, and effortless community spaces—then start with the available floor plans to find your fit.</p>",
  "property_long_description": "<p><strong>Modern lakeside living with Richmond within easy reach.</strong> At Boulders Lakeside, you can settle into a polished one- or two-bedroom apartment in North Chesterfield with the space, finishes, and community features that make everyday routines feel effortless. Inside, chef-inspired kitchens, tile backsplashes, hard-surface flooring, in-home conveniences, and generous storage create a clean, contemporary backdrop for the way you live.</p><p>Step outside and the community keeps the momentum going with a <a href=\"/amenities\">resort-style pool</a>, clubhouse, fitness center, yoga/flex studio, cyber cafe, game room, grilling areas, dog wash, and online resident services. When you’re ready to explore, your address places you near Chippenham Hospital, Boulders Office Park, Powhite Parkway, and Chippenham Parkway, with quick access to Downtown Richmond. Stony Point Fashion Park, Powhite Park’s wooded trails, Forest Hill Park, South of the James Market, and the James River all add local flavor, outdoor space, and weekend possibilities close to home. Start with the <a href=\"/floor-plans\">available floor plans</a> and find your fit.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-9a81-705d-84c9-b9a70b57faf7.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury apartment building with an outdoor swimming pool and lounge chairs.",
    "public_id": "019e897f-9a81-705d-84c9-b9a70b57faf7",
    "storage_key": "property/5722559043600384/019e897f-9a81-705d-84c9-b9a70b57faf7.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "460",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.73913043478261",
  "property_admin_fee": "200",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Application Approval Fee: Starting at $499\nReservation Fee: $200\nApplication Fee: $50\nPet Fee: $350/pet Non-Refundable\nMonthly Pet Rent: $35/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8798653.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://boulderslakeside.loftliving.com/login",
  "property_apply_now_url": "https://8798653.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019df5dc-03e9-759a-aaf1-4d10c5a3cc45.webp",
  "property_primary_logo_media": {
    "alt_text": "Boulders Lakeside & Lakeview Apartments logo",
    "public_id": "019df5dc-03e9-759a-aaf1-4d10c5a3cc45",
    "storage_key": "property/5722559043600384/019df5dc-03e9-759a-aaf1-4d10c5a3cc45.webp",
    "width": 1797,
    "height": 1018
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019df5dc-0632-7183-b0eb-7b5ed3b583cd.webp",
  "property_secondary_logo_media": {
    "alt_text": "Boulders Lakeside & Lake View Apartments logo",
    "public_id": "019df5dc-0632-7183-b0eb-7b5ed3b583cd",
    "storage_key": "property/5722559043600384/019df5dc-0632-7183-b0eb-7b5ed3b583cd.webp",
    "width": 3000,
    "height": 3000
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019df5dc-7977-71cf-8a18-2686d56215ab.webp",
  "property_icon_media": {
    "alt_text": "BL logo with a leaf design",
    "public_id": "019df5dc-7977-71cf-8a18-2686d56215ab",
    "storage_key": "property/5722559043600384/019df5dc-7977-71cf-8a18-2686d56215ab.webp",
    "width": 568,
    "height": 568
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019df5dc-7977-71cf-8a18-2686d56215ab.webp",
  "property_fav_icon_media": {
    "alt_text": "BL logo with a leaf design",
    "public_id": "019df5dc-7977-71cf-8a18-2686d56215ab",
    "storage_key": "property/5722559043600384/019df5dc-7977-71cf-8a18-2686d56215ab.webp",
    "width": 568,
    "height": 568
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1559-baaa-731c-afd0-b84c74432c4f.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f1559-baaa-731c-afd0-b84c74432c4f",
    "storage_key": "property/5722559043600384/019f1559-baaa-731c-afd0-b84c74432c4f.webp",
    "width": 1280,
    "height": 725
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1559-af10-76bc-a470-4dd8a4fa647f.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f1559-af10-76bc-a470-4dd8a4fa647f",
    "storage_key": "property/5722559043600384/019f1559-af10-76bc-a470-4dd8a4fa647f.webp",
    "width": 1280,
    "height": 725
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#16959a",
  "property_secondary_color": "#0b395c",
  "property_font_color": "#80cacc",
  "property_color_4": "#575757",
  "property_color_3": "#2e2a25",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "740 - 1156",
  "property_sqft_min": "740",
  "property_sqft_max": "1156",
  "property_price_range": "1585 - 2145",
  "property_price_min": "1585",
  "property_price_max": "2145",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/liveboulderslakeside",
  "property_instagram_url": "https://www.instagram.com/liveboulderslakeside",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJT-A_dsMTsYkRtnbeyDFyOJU",
  "property_youtube_url": "https://www.youtube.com/@BouldersLakeside",
  "property_yelp_url": "https://www.yelp.com/biz/boulders-lakeside-apartments-by-rkw-residences-north-chesterfield",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities built for more of your day.</strong> Start in the fitness center or yoga/flex studio, settle in at the cyber cafe, then switch scenes at the pool, clubhouse, game room, or grilling area. A dog wash and online resident services add everyday ease, while apartment interiors bring chef-inspired kitchens, tile backsplashes, hard-surface flooring, soaking tubs, and select outdoor space or storage.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose a layout with room to breathe.</strong> Boulders Lakeside pairs one- and two-bedroom apartments with open living areas, defined bedrooms, and smart everyday storage. Explore finishes like quartz countertops, stainless-steel appliances, subway tile backsplashes, plank flooring, walk-in closets, keyless entry, in-home laundry, and select private outdoor spaces—then compare featured plans and current availability.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Boulders Lakeside.</strong> Preview bright interiors with chef-style kitchens, tile backsplashes, hard-surface floors, and open living spaces, then keep browsing for the pool, clubhouse, fitness studio, yoga/flex space, cyber cafe, and grill area. Every image adds shape to the North Chesterfield setting.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lakeside living with Southside Richmond in reach.</strong> From Boulders Lakeside, everyday stops and weekend plans come together fast—Crossroads coffee and ice cream, groceries at Trader Joe’s or Good Foods Grocery, dinner at Southbound, and movies at Stony Point Fashion Park. Powhite Park, Forest Hill Park, and South of the James Market add fresh-air appeal, while Powhite and Chippenham Parkways connect you to Downtown Richmond, VCU, Maymont, and the James River.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews point to an easy move-in and everyday comfort.</strong><br>Residents praise the painless rental process, responsive leasing support, and clean, modern apartments with roomy kitchens, generous closets, and quality finishes. The lakeside setting stands out, too, with pet-friendly green space, nearby trails, peaceful trees, and wildlife views that make daily life feel connected to nature. Read more to see what residents are saying about Boulders Lakeside.</p>",
  "property_neighborhood_blurb": "<p><strong>Explore Southside Richmond from a lakeside address.</strong> From Boulders Lakeside, you’re positioned between North Chesterfield convenience and the character of Richmond’s Forest Hill corridor. Make a quick coffee-and-ice-cream stop at Crossroads, stock the kitchen at Trader Joe’s or Good Foods Grocery in Stony Point Shopping Center, then keep the day going with dinner at Southbound or a movie-night outing at Stony Point Fashion Park. When you want fresh air, nearby Powhite Park offers wooded trails, while Forest Hill Park brings year-round market energy with South of the James Market. Powhite Parkway and Chippenham Parkway keep Downtown Richmond, VCU, Maymont, and the James River easy to reach—so your map fills in fast from home. Ready to see the setting for yourself? <a href=\"/schedule-a-tour\">Schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces with real everyday range.</strong> At Boulders Lakeside, your routine can move from a morning session in the fitness center or yoga/flex studio to laptop time in the cyber cafe, then out to the pool, clubhouse, game room, or grill area when you want a change of scenery. Pet-friendly perks include a convenient <a href=\"/pet-policy\">dog wash</a>, while online resident services help keep account tasks simple.</p><p>Inside your North Chesterfield apartment, polished finishes keep the experience just as thoughtful: chef-inspired kitchens with tile backsplashes, hard-surface flooring, soaking tubs, and available outdoor space or storage in select homes. Explore the <a href=\"/gallery\">photo gallery</a> to see how the details come together, then <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Boulders Lakeside home?</strong> Start your application online for a polished one- or two-bedroom apartment with chef-inspired kitchens, hard-surface flooring, in-home conveniences, and generous storage—all in a modern lakeside setting with Richmond within easy reach.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong><br>Contact the leasing team at Boulders Lakeside for details on polished one- and two-bedroom apartments, modern finishes, community features, or directions to our North Chesterfield address with Richmond within easy reach.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Boulders Lakeside?</strong> Start here for quick answers on leasing, apartment features, community amenities, and everyday living in North Chesterfield. If you need more details, our leasing team is happy to help—just <a href=\"/contact-us\">contact us</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Boulders Lakeside offers one- and two-bedroom apartments in North Chesterfield with open-concept living areas, defined bedrooms, and the everyday storage that helps your space stay streamlined.</p><p>Compare cozy one-bedroom designs with roomier two-bedroom, two-bath layouts, then look for the finishes that make each home feel polished: chef-inspired kitchens, quartz countertops, stainless-steel appliances, subway tile backsplashes, plank flooring, walk-in closets, keyless entry, in-home laundry, and private outdoor space in select homes. Use the floor plan cards below to review current pricing and availability, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See Boulders Lakeside from every angle.</strong> Browse photos that move from bright apartment interiors to polished shared spaces, giving you a clear sense of how the community looks, feels, and flows in North Chesterfield.</p><p>Notice the clean lines of chef-style kitchens, tile backsplashes, hard-surface floors, and open living areas made for easy arranging. Then picture the day beyond your front door: sunlight around the <a href=\"/amenities\">pool and clubhouse</a>, a focused stretch in the fitness or yoga/flex studio, a quick stop at the cyber cafe, or a casual evening by the grill area. When a view catches your eye, compare layouts on the <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available apartments at Boulders Lakeside and see how North Chesterfield living connects to nearby parks, shopping, major parkways, and Downtown Richmond access—all from one interactive view.</p>",
  "property_pets_blurb": "<p><strong>Bring the pets who make your space feel complete.</strong> At Boulders Lakeside, cats and dogs can settle into apartment living with room to stretch, relax, and join the rhythm of your day. After a walk around the community or a muddy-weather outing, the on-site dog wash helps make cleanup simple before heading back to your home.</p><p>Pet-friendly living here goes beyond the front door, with outdoor space around the community and nearby places to add variety to your routine in North Chesterfield. Explore layouts with the space and finishes that work for daily life on the <a href=\"/floor-plans\">floor plans</a> page, see more pet-friendly perks on <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to picture life here with your cat or dog.</p>",
  "property_referafriend_blurb": "<p><strong>Love lakeside living at Boulders Lakeside?</strong> Share the polished apartments, effortless in-home finishes, generous storage, and inviting community spaces that make life here feel easy. Send a referral today and help a friend find their next one- or two-bedroom home in North Chesterfield.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Boulders Lakeside.</strong><br>Keep everyday routines effortless with online resident services. Log in to pay rent, submit maintenance requests, and manage your account—all from the same polished North Chesterfield community you call home.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate about Boulders Lakeside.</strong><br>Reviews highlight a “very impressive and painless rental process,” helpful leasing support, and a team described as attentive, informative, and quick to respond. Residents also call out clean, modern apartments with quality fixtures, roomy kitchens, generous closet space, and comfortable bathroom counter space. Outside the apartment, the setting gets plenty of love: space for pets, a scenic trail and bike path nearby, peaceful trees around the community, and lake views with wildlife sightings. Browse the reviews below to see what day-to-day living here has meant to the people sharing their experience.</p>",
  "property_created_at": "1752256616199",
  "property_scheduletour_blurb": "<p><strong>See lakeside living up close.</strong> Tour Boulders Lakeside and picture polished one- or two-bedroom spaces with chef-inspired kitchens, tile backsplashes, hard-surface flooring, in-home conveniences, and generous storage. Then explore the community spaces that keep daily routines effortless. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will be in touch soon. In the meantime, picture modern lakeside living at Boulders Lakeside, with polished one- and two-bedroom apartments, contemporary finishes, generous storage, and community spaces designed to make everyday routines feel effortless.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through before you visit.</strong> Explore the available one-bedroom, one-bath virtual tour at Boulders Lakeside and get a closer feel for the apartment’s flow from wherever you are. Move from the open living area into a chef-inspired kitchen with modern finishes, then take in details like hard-surface flooring, natural light, bedroom placement, and the way the bathroom and storage areas support everyday routines.</p><p>Use the tour to picture furniture placement, compare it with available <a href=\"/floor-plans\">one-bedroom layouts</a>, and decide what you want to see next in person. When you’re ready for a closer look at Boulders Lakeside in North Chesterfield, <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_copyright": "2025 All Rights Reserved. Boulders Lakeside",
  "property_seo_title_home": "Boulders Lakeside | Apartments in North Chesterfield, VA",
  "property_seo_description_home": "Experience lakeside living at Boulders Lakeside in North Chesterfield, VA. Enjoy spacious one- and two-bedroom layouts, luxury amenities, and serene views.",
  "property_seo_title_floorplans": "Find your ideal space at Boulders Lakeside in North Chesterfield, VA. Choose from stylish one or two-bedroom floor plans that suit your lifestyle.",
  "property_seo_description_floorplans": "Unveil your ideal living space at Boulders Lakeside in North Chesterfield, VA. From cozy one-bedrooms to spacious two-bedrooms, the perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | North Chesterfield, VA Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Boulders Lakeside in North Chesterfield, VA. Enjoy our chef’s kitchen, fitness center, and scenic water views—your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in North Chesterfield, VA",
  "property_seo_description_gallery": "\"Picture life at Boulders Lakeside in North Chesterfield, VA! Revel in stunning views and luxurious amenities from a cozy clubhouse to a refreshing poolside escape.\"",
  "property_seo_title_virtualtours": "Virtual Tours | Boulders Lakeside Apartments",
  "property_seo_description_virtualtours": "Experience lakeside living at Boulders Lakeside in North Chesterfield, VA. Take a virtual tour of our stylish one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Boulders Lakeside Apartments",
  "property_seo_description_interactivemap": "Find your perfect sanctuary at Boulders Lakeside in North Chesterfield, VA. Dive into our interactive map to explore stunning one- and two-bedroom homes with premium amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Chesterfield, VA",
  "property_seo_description_neighborhood": "Uncover the charm of North Chesterfield at Boulders Lakeside! Check out nearby favorites and vibrant attractions that make our community truly special.",
  "property_seo_title_contact": "Contact Us | Boulders Lakeside",
  "property_seo_description_contact": "Experience lakeside living at Boulders Lakeside in North Chesterfield, VA. From cozy one-bedrooms to spacious two-bedrooms, we’re here to help you find your home!",
  "property_seo_title_faqs": "FAQs | Apartments in North Chesterfield, VA",
  "property_seo_description_faqs": "Find answers to your burning questions at Boulders Lakeside in North Chesterfield, VA. Learn about our amenities, floor plans, and living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Chesterfield, VA",
  "property_seo_description_reviews": "\"Experience life at Boulders Lakeside in North Chesterfield, VA. Check out resident reviews and see why our community is the perfect place to call home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in North Chesterfield, VA",
  "property_seo_description_applynow": "Welcome to Boulders Lakeside in North Chesterfield! Choose from stylish one and two-bedroom apartments featuring chef's kitchens, a pool, fitness center, and more.",
  "property_seo_title_residentaccess": "Resident Access | Boulders Lakeside",
  "property_seo_description_residentaccess": "\"Welcome to Boulders Lakeside's resident portal! Effortlessly manage your stay in North Chesterfield—pay rent, schedule maintenance, and much more, all online!\"",
  "property_seo_title_referafriend": "Refer A Friend | Boulders Lakeside",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to Boulders Lakeside in North Chesterfield, VA, and enjoy exclusive rewards together in our vibrant community.\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Boulders Lakeside",
  "property_seo_description_scheduletour": "Embrace lakeside living at Boulders Lakeside, North Chesterfield. Ready to find your dream home? Schedule a tour today and step into your new lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Boulders Lakeside",
  "property_seo_description_privacy": "Safeguarding your peace of mind at Boulders Lakeside. Learn how we protect your information in our comprehensive privacy policy. View it now!",
  "property_seo_title_accessibility": "Website Accessibility | Boulders Lakeside",
  "property_seo_description_accessibility": "\"At Boulders Lakeside in North Chesterfield, VA, we champion digital inclusion, ensuring a seamless experience for all. Join our accessible community today!\"",
  "property_seo_title_sitemap": "Sitemap | Boulders Lakeside",
  "property_seo_description_sitemap": "Uncover pathways to your dream home at Boulders Lakeside in North Chesterfield, VA. Navigate our sitemap for vibrant community highlights and floor plans!",
  "property_seo_title_thankyou": "Thank You | Boulders Lakeside",
  "property_seo_description_thankyou": "Thank you for reaching out to Boulders Lakeside in North Chesterfield! Our team will connect soon to help you find your perfect lakeside home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319455",
  "amenities": [
    {
      "id": "custom_6ef5e57b-62dd-4bd8-8d8b-36cfb7895cd2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_516a258e-507e-4706-9149-8074d3c8458f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Chef-Inspired Kitchens",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_abd46fe0-c1f6-418a-9c2b-409df2518f1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_15020376-8c26-4f3b-a0c2-c8f4d834e602",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000628",
      "title": "Dog Wash",
      "amount": "0.0000",
      "description": "Dog Wash Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f50c658d-fa10-499b-9f55-f22a25421520",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2cda28d4-d9b2-4e39-8ed5-ec66db9af22b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000639",
      "title": "Game Room",
      "amount": "0.0000",
      "description": "Community Gaming Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d7e043c-ae2f-4d14-82ef-ee3101f54c3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b6290b11-f664-4070-943a-2a84da2c52ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_264b96d4-8e3b-4d04-91cf-89d7fecf0fee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c9c6f64-5e7b-41a3-a179-d420e32a5faa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47cdf916-e989-4104-b252-2bba2676a524",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31ca7242-cc99-47e6-aa8a-afaa82a000a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ef35a31c-de34-4bb4-b193-4d11b48ec668",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Onsite Storage Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fa599a4-2a77-4f10-8a99-5ca05b436b97",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_901b12c3-6c6f-412a-b867-128b2e0f0691",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Roman Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_257ec8fe-82d6-4f7a-b50e-5f43083d9b5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Cyber Cafe",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_809ca28a-2e5d-4787-ab23-f3c287fcaa5a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "external_id": "P000002466",
      "title": "Yoga/Flex Studio",
      "amount": "0.0000",
      "description": "Yoga/flex studio with Fitness on Demand",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_45c47dd4-a1b8-4721-a2c7-d582eebf4639",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-a2cc-7743-b6e9-49170965ebff.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, toilet, vanity, and a closet.",
        "public_id": "019e897f-a2cc-7743-b6e9-49170965ebff",
        "storage_key": "property/5722559043600384/019e897f-a2cc-7743-b6e9-49170965ebff.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern bathroom featuring a walk-in shower, a convenient vanity, and ample closet space for all your storage needs.",
      "link": "",
      "alt_text": "Modern bathroom with a walk-in shower, toilet, vanity, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39e5dfb0-5646-4e71-a970-703b24bde055",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-a0bc-710b-8f1e-811273f1eb9b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island, and light wood cabinetry.",
        "public_id": "019e897f-a0bc-710b-8f1e-811273f1eb9b",
        "storage_key": "property/5722559043600384/019e897f-a0bc-710b-8f1e-811273f1eb9b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, a large island with seating, and elegant light wood cabinetry. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, island, and light wood cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_25d5ab59-0aa8-4c5d-a3ee-b47ea264287f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-a465-708f-8811-07efdc45056e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, large mirror, bathtub with shower curtain, and dark wood flooring.",
        "public_id": "019e897f-a465-708f-8811-07efdc45056e",
        "storage_key": "property/5722559043600384/019e897f-a465-708f-8811-07efdc45056e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience luxury in our well-appointed bathrooms, featuring a spacious vanity, ample storage, and a relaxing bathtub. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, large mirror, bathtub with shower curtain, and dark wood flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_53f54428-4087-4db3-bb4b-893d093731ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-a0b6-754e-8c27-eae53c98ae15.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multi-story apartment building with balconies and stone accents.",
        "public_id": "019e897f-a0b6-754e-8c27-eae53c98ae15",
        "storage_key": "property/5722559043600384/019e897f-a0b6-754e-8c27-eae53c98ae15.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View the exterior of our apartment building, featuring modern architecture, private balconies, and attractive stone accents.",
      "link": "",
      "alt_text": "Exterior view of a modern multi-story apartment building with balconies and stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc987770-cd2e-4188-b73a-f9593d701093",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-9dcc-744d-a15a-7dabf5464a34.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and adjacent kitchen area with bar seating.",
        "public_id": "019e897f-9dcc-744d-a15a-7dabf5464a34",
        "storage_key": "property/5722559043600384/019e897f-9dcc-744d-a15a-7dabf5464a34.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this stylish living area, featuring a large sectional sofa and a modern open-concept kitchen with bar seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Spacious living room with a sectional sofa, coffee table, and adjacent kitchen area with bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd97c98e-46f4-4c46-8efc-6c901cc38fb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-9a81-705d-84c9-b9a70b57faf7.webp",
      "image_media": {
        "alt_text": "Luxury apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "019e897f-9a81-705d-84c9-b9a70b57faf7",
        "storage_key": "property/5722559043600384/019e897f-9a81-705d-84c9-b9a70b57faf7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a beautiful pergola.",
      "link": "",
      "alt_text": "Luxury apartment building with an outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3297a884-e0d9-48e0-ae15-e7fa290e55c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-84d1-75a4-a04b-543a468c1e44.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, rowing machine, weight racks, and benches.",
        "public_id": "019e897f-84d1-75a4-a04b-543a468c1e44",
        "storage_key": "property/5722559043600384/019e897f-84d1-75a4-a04b-543a468c1e44.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and weight training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, rowing machine, weight racks, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39f1399b-4a69-4ace-80a4-e5459d3f41c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-6460-7653-a1d7-9a2045a82b5a.webp",
      "image_media": {
        "alt_text": "Hallway leading to a lounge area with a fireplace and seating.",
        "public_id": "019e897f-6460-7653-a1d7-9a2045a82b5a",
        "storage_key": "property/5722559043600384/019e897f-6460-7653-a1d7-9a2045a82b5a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Elegant hallway with modern decor leading to a stylish lounge with a fireplace and comfortable seating, perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Hallway leading to a lounge area with a fireplace and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f86c8817-c00d-44b8-88d3-9977c688d134",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-795c-73bf-9543-16329eb74f42.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, toilet, and bathtub with a shower curtain.",
        "public_id": "019e897f-795c-73bf-9543-16329eb74f42",
        "storage_key": "property/5722559043600384/019e897f-795c-73bf-9543-16329eb74f42.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this modern bathroom featuring a sleek vanity, a comfortable toilet, and a pristine bathtub with an elegant shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, toilet, and bathtub with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96eae6b1-da64-4d2b-80bc-0fecf39300e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-7a6c-73e4-bb1c-75765bac993c.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with blue chairs around a fire pit and a pergola.",
        "public_id": "019e897f-7a6c-73e4-bb1c-75765bac993c",
        "storage_key": "property/5722559043600384/019e897f-7a6c-73e4-bb1c-75765bac993c.webp",
        "width": 2554,
        "height": 1703
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor seating area, complete with comfortable chairs and a cozy fire pit, perfect for evening gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with blue chairs around a fire pit and a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f84da025-a409-41b3-8446-558ece50a51d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-7c7d-708d-83ee-b66174265e89.webp",
      "image_media": {
        "alt_text": "Two blue Adirondack chairs on a porch overlooking a pool and apartment buildings.",
        "public_id": "019e897f-7c7d-708d-83ee-b66174265e89",
        "storage_key": "property/5722559043600384/019e897f-7c7d-708d-83ee-b66174265e89.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax on the porch in these inviting Adirondack chairs, with a view of the sparkling pool and lush landscaping. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Two blue Adirondack chairs on a porch overlooking a pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b150bb53-91ab-4412-b960-670e522ad6bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-7d37-7485-a5d8-88f9c74d45ab.webp",
      "image_media": {
        "alt_text": "Community lounge area with poker table and seating.",
        "public_id": "019e897f-7d37-7485-a5d8-88f9c74d45ab",
        "storage_key": "property/5722559043600384/019e897f-7d37-7485-a5d8-88f9c74d45ab.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a game night in our stylish community lounge, featuring a poker table, comfortable seating, and a large screen TV.",
      "link": "",
      "alt_text": "Community lounge area with poker table and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85aac514-ed3b-4d09-9ac4-7c813fb6d2c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-7b1f-761a-9f81-8d6c9243632f.webp",
      "image_media": {
        "alt_text": "Exterior view of Boulders Lakeside apartment buildings with landscaping and signage.",
        "public_id": "019e897f-7b1f-761a-9f81-8d6c9243632f",
        "storage_key": "property/5722559043600384/019e897f-7b1f-761a-9f81-8d6c9243632f.webp",
        "width": 2535,
        "height": 1690
      },
      "title": "Community",
      "description": "Discover the elegant exterior of Boulders Lakeside, showcasing modern apartment buildings surrounded by lush landscaping and a welcoming monument sign.",
      "link": "",
      "alt_text": "Exterior view of Boulders Lakeside apartment buildings with landscaping and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f78d2462-824b-45ec-9c53-688363b19979",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-7ca7-75b2-8ed4-1f3aaa0d7c68.webp",
      "image_media": {
        "alt_text": "Ping pong table and outdoor seating area with pergola at apartment complex.",
        "public_id": "019e897f-7ca7-75b2-8ed4-1f3aaa0d7c68",
        "storage_key": "property/5722559043600384/019e897f-7ca7-75b2-8ed4-1f3aaa0d7c68.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation and relaxation with a ping pong table, comfortable seating, and a shaded pergola area at this apartment community.",
      "link": "",
      "alt_text": "Ping pong table and outdoor seating area with pergola at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_48eed3d0-2b13-46a9-a0ca-5f481c634363",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-758a-76d1-a025-8a1efe7dd764.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, seating, and a TV.",
        "public_id": "019e897f-758a-76d1-a025-8a1efe7dd764",
        "storage_key": "property/5722559043600384/019e897f-758a-76d1-a025-8a1efe7dd764.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy our resident lounge featuring a pool table, comfortable seating, and a large screen TV for entertainment.",
      "link": "",
      "alt_text": "Community lounge with a pool table, seating, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab9ba429-2481-4499-9e80-b8ab17c6585c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-75b2-72ab-bd5c-400749b735b9.webp",
      "image_media": {
        "alt_text": "In-unit laundry with washer and dryer.",
        "public_id": "019e897f-75b2-72ab-bd5c-400749b735b9",
        "storage_key": "property/5722559043600384/019e897f-75b2-72ab-bd5c-400749b735b9.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a full-size washer and dryer, making chores a breeze. Includes storage shelves above for detergent and supplies.",
      "link": "",
      "alt_text": "In-unit laundry with washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_803bf49c-2e2d-4660-8fc8-b05222ded76e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-6ee4-702f-824b-8a358ce05723.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, large mirror, walk-in closet, and a glass-enclosed shower.",
        "public_id": "019e897f-6ee4-702f-824b-8a358ce05723",
        "storage_key": "property/5722559043600384/019e897f-6ee4-702f-824b-8a358ce05723.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a sleek double vanity, a large mirror reflecting the glass-enclosed shower, and a convenient walk-in closet.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, large mirror, walk-in closet, and a glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a1e5bee-14f3-4a5b-80cf-c25dde9749bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-5744-7679-979d-633775e57297.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with cabana seating and lounge chairs.",
        "public_id": "019e897f-5744-7679-979d-633775e57297",
        "storage_key": "property/5722559043600384/019e897f-5744-7679-979d-633775e57297.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, perfect for relaxing and unwinding. Ample lounge seating and a shaded cabana provide comfort and convenience for all residents.",
      "link": "",
      "alt_text": "Resort-style swimming pool with cabana seating and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_10d1789a-1180-4eda-a8fa-04ba0f428201",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-631a-7298-bf3d-d586c42bb8b3.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a large island bar, seating, and a TV.",
        "public_id": "019e897f-631a-7298-bf3d-d586c42bb8b3",
        "storage_key": "property/5722559043600384/019e897f-631a-7298-bf3d-d586c42bb8b3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and entertain in our stylish community lounge, featuring a spacious island bar, comfortable seating, and a large TV for your enjoyment.",
      "link": "",
      "alt_text": "Modern community lounge with a large island bar, seating, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d836d19-2f62-4b6b-b393-f1f054a5f157",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-48ee-7271-8965-f3aea93432bc.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, rowing machine, and free weights.",
        "public_id": "019e897f-48ee-7271-8965-f3aea93432bc",
        "storage_key": "property/5722559043600384/019e897f-48ee-7271-8965-f3aea93432bc.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, rowing machine, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2571b27e-d6f9-471f-a698-7a792a354a13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-631e-7788-a773-b930ae051238.webp",
      "image_media": {
        "alt_text": "Closet with organized hangers and a view into a bedroom.",
        "public_id": "019e897f-631e-7788-a773-b930ae051238",
        "storage_key": "property/5722559043600384/019e897f-631e-7788-a773-b930ae051238.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample storage and a peek into a comfortable bedroom, offering a glimpse of the apartment's interior design.",
      "link": "",
      "alt_text": "Closet with organized hangers and a view into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ee0bfd44-94de-413a-a547-188a019555d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-5323-75ac-ac72-4c8f2a33edea.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and open-concept kitchen.",
        "public_id": "019e897f-5323-75ac-ac72-4c8f2a33edea",
        "storage_key": "property/5722559043600384/019e897f-5323-75ac-ac72-4c8f2a33edea.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly transitions to a fully equipped kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and open-concept kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4078fd0f-791e-4645-ac37-d452f5715d97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-5be6-764e-bbcb-27b6b5204515.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, blue accent wall, and a doorway to the bathroom.",
        "public_id": "019e897f-5be6-764e-bbcb-27b6b5204515",
        "storage_key": "property/5722559043600384/019e897f-5be6-764e-bbcb-27b6b5204515.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a vibrant blue accent wall adorned with artwork, and convenient access to a well-appointed bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, blue accent wall, and a doorway to the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d474703-cee2-4cfb-b04c-f788b8090bc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-56c9-714f-a698-4235b52d5bf6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with walk-in shower and double vanity, view into bedroom.",
        "public_id": "019e897f-56c9-714f-a698-4235b52d5bf6",
        "storage_key": "property/5722559043600384/019e897f-56c9-714f-a698-4235b52d5bf6.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious and elegant bathroom featuring a glass-enclosed walk-in shower, a modern double vanity with ample counter space, and a view into a well-appointed bedroom.",
      "link": "",
      "alt_text": "Modern bathroom with walk-in shower and double vanity, view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_531f9f5a-45a0-40a0-bbc4-39670883d2b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-55e8-700d-895f-e12ca93cda18.webp",
      "image_media": {
        "alt_text": "Lounge area with pool table, seating, and high top tables.",
        "public_id": "019e897f-55e8-700d-895f-e12ca93cda18",
        "storage_key": "property/5722559043600384/019e897f-55e8-700d-895f-e12ca93cda18.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy leisure time in our resident lounge, featuring a pool table, comfortable seating areas, and convenient high-top tables for work or socializing.",
      "link": "",
      "alt_text": "Lounge area with pool table, seating, and high top tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_deac47e8-29c1-42bb-94bd-76f2569a02a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-4436-7759-8026-e3270c2d8a56.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and white countertops.",
        "public_id": "019e897f-4436-7759-8026-e3270c2d8a56",
        "storage_key": "property/5722559043600384/019e897f-4436-7759-8026-e3270c2d8a56.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring stainless steel appliances, ample cabinet space, and pristine countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ce86266-4ab8-4ff8-84ab-43b4d887549d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2d70-76bc-802b-29506b6bf7b1.webp",
      "image_media": {
        "alt_text": "Community lounge with two orange sofas, a fireplace with a TV above, and a pool table in the background.",
        "public_id": "019e897f-2d70-76bc-802b-29506b6bf7b1",
        "storage_key": "property/5722559043600384/019e897f-2d70-76bc-802b-29506b6bf7b1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a modern fireplace, and a billiards table for entertainment.",
      "link": "",
      "alt_text": "Community lounge with two orange sofas, a fireplace with a TV above, and a pool table in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4011e73-742e-4c5c-a98c-edfa5276db55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-43e3-7602-8147-4e4188cf493e.webp",
      "image_media": {
        "alt_text": "Pool table in a modern apartment community lounge with a fireplace and large windows.",
        "public_id": "019e897f-43e3-7602-8147-4e4188cf493e",
        "storage_key": "property/5722559043600384/019e897f-43e3-7602-8147-4e4188cf493e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in our stylish community lounge, featuring comfortable seating, a fireplace, and ample natural light.",
      "link": "",
      "alt_text": "Pool table in a modern apartment community lounge with a fireplace and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31f7178e-db1c-44a9-85d0-cc25fc00c936",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2d3c-75ee-aafa-e7b238f2448a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools.",
        "public_id": "019e897f-2d3c-75ee-aafa-e7b238f2448a",
        "storage_key": "property/5722559043600384/019e897f-2d3c-75ee-aafa-e7b238f2448a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek dark wood cabinetry, a full suite of stainless steel appliances, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ddd648a1-a48e-44a8-ae7c-fc230dfb54b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2ece-74bb-940d-0b073fd9ef82.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, navy blue accent wall, and window.",
        "public_id": "019e897f-2ece-74bb-940d-0b073fd9ef82",
        "storage_key": "property/5722559043600384/019e897f-2ece-74bb-940d-0b073fd9ef82.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring a comfortable queen-size bed, a striking navy blue accent wall adorned with artwork, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Bedroom with a large bed, navy blue accent wall, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb9856d1-391a-4031-9578-0cbf380b1cf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2cfc-7279-afda-829672363036.webp",
      "image_media": {
        "alt_text": "Living room and bedroom of a multifamily apartment unit.",
        "public_id": "019e897f-2cfc-7279-afda-829672363036",
        "storage_key": "property/5722559043600384/019e897f-2cfc-7279-afda-829672363036.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish living room with a sectional sofa and a view of the bedroom. Perfect for modern living.",
      "link": "",
      "alt_text": "Living room and bedroom of a multifamily apartment unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7122654-bfef-475e-bc07-aa3ebed179c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2e67-730f-ad53-fdbeb50379b1.webp",
      "image_media": {
        "alt_text": "Blue adirondack chairs around a fire pit in an outdoor common area, with apartment buildings in the background.",
        "public_id": "019e897f-2e67-730f-ad53-fdbeb50379b1",
        "storage_key": "property/5722559043600384/019e897f-2e67-730f-ad53-fdbeb50379b1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and gather around the fire pit with friends and neighbors in this inviting outdoor lounge area. Perfect for enjoying the evening air.",
      "link": "",
      "alt_text": "Blue adirondack chairs around a fire pit in an outdoor common area, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73d458e7-41bf-4b8b-842d-e604a5a3eea9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2e68-76ee-9738-ebc3b376c8b0.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room in an apartment with stainless steel appliances and natural light.",
        "public_id": "019e897f-2e68-76ee-9738-ebc3b376c8b0",
        "storage_key": "property/5722559043600384/019e897f-2e68-76ee-9738-ebc3b376c8b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the ultimate in urban living with this stunning apartment featuring a gourmet kitchen and open-concept living area, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living room in an apartment with stainless steel appliances and natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90bfe438-deae-4eb8-a9b3-105bb9284e88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2e83-769e-950c-de98031199fa.webp",
      "image_media": {
        "alt_text": "Outdoor living area with fireplace, seating, and dining table.",
        "public_id": "019e897f-2e83-769e-950c-de98031199fa",
        "storage_key": "property/5722559043600384/019e897f-2e83-769e-950c-de98031199fa.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this beautifully designed community space, featuring a stone fireplace, comfortable seating, and an outdoor dining area.",
      "link": "",
      "alt_text": "Outdoor living area with fireplace, seating, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9148f5be-466f-45fe-9a77-b69ff4bb6c33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-2ce9-7658-bcc6-8f8e95ddf901.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dark gray accent wall, and large window.",
        "public_id": "019e897f-2ce9-7658-bcc6-8f8e95ddf901",
        "storage_key": "property/5722559043600384/019e897f-2ce9-7658-bcc6-8f8e95ddf901.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed bedroom, featuring a comfortable king-size bed and a chic dark gray accent wall.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dark gray accent wall, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21e2095d-14ae-4d47-b4cf-dc46a7926958",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-224d-7709-a042-8605010900c4.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with spin bikes, dumbbells, and exercise balls.",
        "public_id": "019e897f-224d-7709-a042-8605010900c4",
        "storage_key": "property/5722559043600384/019e897f-224d-7709-a042-8605010900c4.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and free weights.",
      "link": "",
      "alt_text": "Modern apartment gym with spin bikes, dumbbells, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b280a379-edf4-4e90-b75a-99f4ec9835ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019e897f-22cb-713c-9d7e-f2a77ac316b8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and clubhouse.",
        "public_id": "019e897f-22cb-713c-9d7e-f2a77ac316b8",
        "storage_key": "property/5722559043600384/019e897f-22cb-713c-9d7e-f2a77ac316b8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable loungers. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool and clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_dbd68f4723568fdaa77cc5d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Beas Bakery & Deli",
      "poi_type": "Restaurants",
      "poi_address": "7501 Boulder View Dr #125, North Chesterfield, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929278963864720845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beas-bakery--deli",
      "poi_latitude": "37.5129348",
      "poi_longitude": "-77.5346746",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-592-5625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSbsdQukSsYkRzVVaj80HSVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_b3a866a268285b85719eec7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "LB Cafe 2",
      "poi_type": "Restaurants",
      "poi_address": "7501 Boulder View Dr, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14130422689824674570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lb-cafe-2",
      "poi_latitude": "37.5129348",
      "poi_longitude": "-77.5346746",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-726-3445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeY4fjEkTsYkRCpMe-ZFYGcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ccea213b7f644f96586fb47e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Punjab Kitchen Indian Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "101 Stonebridge Plaza Ave, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Casual, kid-friendly eatery for traditional Indian dishes, including vegetarian options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-974e-720b-94ca-da292fc5acbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-974e-720b-94ca-da292fc5acbb",
        "storage_key": "property/5722559043600384/019f1514-974e-720b-94ca-da292fc5acbb.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://punjabkitchenrva.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15902419763180226823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "punjab-kitchen-indian-cuisine",
      "poi_latitude": "37.4993443",
      "poi_longitude": "-77.5283078",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-447-2677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV3fsjnMTsYkRB0mCHYW-sNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_0e4531ae426103281a7019c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Punjab Kitchen Indian Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "101 Stonebridge Plaza Ave, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Casual, kid-friendly eatery for traditional Indian dishes, including vegetarian options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9752-7378-a71b-99543ad08450.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9752-7378-a71b-99543ad08450",
        "storage_key": "property/5722559043600384/019f1514-9752-7378-a71b-99543ad08450.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://punjabkitchenrva.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15902419763180226823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "punjab-kitchen-indian-cuisine",
      "poi_latitude": "37.4993443",
      "poi_longitude": "-77.5283078",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-447-2677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV3fsjnMTsYkRB0mCHYW-sNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_24f839f11e74c1da0d096c71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "QDOBA Mexican Eats",
      "poi_type": "Restaurants",
      "poi_address": "121 Stonebridge Plaza Ave, North Chesterfield, VA 23236, USA",
      "poi_short_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_long_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-974f-75be-9da5-1e06d7667b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-974f-75be-9da5-1e06d7667b1d",
        "storage_key": "property/5722559043600384/019f1514-974f-75be-9da5-1e06d7667b1d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.qdoba.com/us/va/north-chesterfield/121-stonebridge-plaza-av?utm_medium=organic&utm_source=google&utm_campaign=google_maps&utm_content=website&utm_term=2864",
      "poi_directions_map_url": "https://maps.google.com/?cid=16775193085133711109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qdoba-mexican-eats",
      "poi_latitude": "37.4996409",
      "poi_longitude": "-77.5280593",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-674-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTmd-JESsYkRBef7bTt1zeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_c0b9631961f714466c1d3532",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Subway",
      "poi_type": "Restaurants",
      "poi_address": "153 Stonebridge Plaza Ave Building M, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_long_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9779-7644-800e-c1aabbbb9453.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9779-7644-800e-c1aabbbb9453",
        "storage_key": "property/5722559043600384/019f1514-9779-7644-800e-c1aabbbb9453.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://restaurants.subway.com/united-states/va/n-chesterfield/153-stonebridge-plaza-ave?utm_source=yxt-goog&utm_medium=local&utm_term=acq&utm_content=56878&utm_campaign=evergreen-2020&y_source=1_MTQ4OTgyMTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5190908719548056807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "subway",
      "poi_latitude": "37.4987658",
      "poi_longitude": "-77.527396",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-674-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z_yUYwSsYkR58QjUvrPCUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_10a6cd26b2b22e85e72d5f76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "7106 Midlothian Turnpike, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9737-77fb-b6c6-254c9ab9d381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9737-77fb-b6c6-254c9ab9d381",
        "storage_key": "property/5722559043600384/019f1514-9737-77fb-b6c6-254c9ab9d381.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://locations.chipotle.com/va/north-chesterfield/7106-midlothian-tpke?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2272",
      "poi_directions_map_url": "https://maps.google.com/?cid=4801915489648275985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "37.5013645",
      "poi_longitude": "-77.5283729",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-292-2995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9bC_GpISsYkREXLuObLUo0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_660da4c223fce9d361a4f44f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Tacos El Ingeniero",
      "poi_type": "Restaurants",
      "poi_address": "7429 Midlothian Turnpike, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9cf9-721b-8bd3-5d5e62683016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9cf9-721b-8bd3-5d5e62683016",
        "storage_key": "property/5722559043600384/019f1514-9cf9-721b-8bd3-5d5e62683016.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tacosing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17206737495162527921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacos-el-ingeniero",
      "poi_latitude": "37.4982129",
      "poi_longitude": "-77.5324133",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 804-997-4853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_bdstMTsYkRsaCOLpacyu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_b2790a7f947b6f76d525d513",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "El Vaquero LLC",
      "poi_type": "Restaurants",
      "poi_address": "7461 Midlothian Turnpike, Richmond, VA 23225, USA",
      "poi_short_description": "Tacos, pupusas, and gorditas are on the menu at this casual eatery with a pool table.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9db9-73f4-ad6c-038aad959400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9db9-73f4-ad6c-038aad959400",
        "storage_key": "property/5722559043600384/019f1514-9db9-73f4-ad6c-038aad959400.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elvaquerorva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2418296947448805582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-vaquero-llc",
      "poi_latitude": "37.4975568",
      "poi_longitude": "-77.5345396",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-622-0130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2Ify5YSsYkRzvgY0kKEjyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_ebf6756aecdd1ea6f28bf21d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Waffle House",
      "poi_type": "Restaurants",
      "poi_address": "7497 Midlothian Turnpike, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_long_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9cfa-736d-84cd-524bbc394f29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9cfa-736d-84cd-524bbc394f29",
        "storage_key": "property/5722559043600384/019f1514-9cfa-736d-84cd-524bbc394f29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wafflehouse.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=8869039698454872184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waffle-house",
      "poi_latitude": "37.4993613",
      "poi_longitude": "-77.53442179999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 804-745-4981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSRZ2JASsYkReIA9lZ0oFXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_1508dc55adf02eba16bfce47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Speedy Gonzales Tacos & Tequila",
      "poi_type": "Restaurants",
      "poi_address": "11521 Midlothian Turnpike #H, North Chesterfield, VA 23235, USA",
      "poi_short_description": "Mexican staples, huge margaritas & draft beer offered in roomy, laid-back digs with mariachi music.",
      "poi_long_description": "Mexican staples, huge margaritas & draft beer offered in roomy, laid-back digs with mariachi music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9cfc-707e-a2d5-b739a36b051c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9cfc-707e-a2d5-b739a36b051c",
        "storage_key": "property/5722559043600384/019f1514-9cfc-707e-a2d5-b739a36b051c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.speddytacos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9399810954568693981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedy-gonzales-tacos--tequila",
      "poi_latitude": "37.5043187",
      "poi_longitude": "-77.60994050000001",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-893-3735",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVHxLJ1tsYkR3XjkxkLWcoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_74b13a6c662810555c610a6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "11500 Midlothian Turnpike Ste 478, North Chesterfield, VA 23235, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-9cff-7038-a7a9-fd5f8d690f39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-9cff-7038-a7a9-fd5f8d690f39",
        "storage_key": "property/5722559043600384/019f1514-9cff-7038-a7a9-fd5f8d690f39.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/va/mall-at-chesterfield-towne-center?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13817433816212963286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.5086944",
      "poi_longitude": "-77.6087435",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-794-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzvea51tsYkR1v_XEtliwb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_bb1beb902215c551a5a5d5a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "1118 Courthouse Rd, North Chesterfield, VA 23236, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a27d-75ad-8fec-47a4ba83f908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a27d-75ad-8fec-47a4ba83f908",
        "storage_key": "property/5722559043600384/019f1514-a27d-75ad-8fec-47a4ba83f908.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2207943910214965832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "37.47471",
      "poi_longitude": "-77.59737",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-368-6758",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-e937-71a8-823a-efab4cc9f0c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-e937-71a8-823a-efab4cc9f0c3",
        "storage_key": "property/5722559043600384/019f1514-e937-71a8-823a-efab4cc9f0c3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJBzRKzm5zsYkRSJpZxEkxpB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_819e92631778c4d88e0cf1ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Y Tu Mamá | Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "4910 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Mexican restaurant known for creative street food like tacos and burritos (including birria options) and quesadillas, alongside a selection of beers, some gluten-free.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a465-70ef-8aba-578b4b0c3808.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a465-70ef-8aba-578b4b0c3808",
        "storage_key": "property/5722559043600384/019f1514-a465-70ef-8aba-578b4b0c3808.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://ytumama.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15375066131623715373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "y-tu-mam--mexican-food",
      "poi_latitude": "37.5216877",
      "poi_longitude": "-77.4899002",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-533-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-XAdOATsYkRLSKSpS81X9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_226608105e01075629d08932",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Ocean Crab House",
      "poi_type": "Restaurants",
      "poi_address": "5726 Hopkins Rd, Richmond, VA 23234, USA",
      "poi_short_description": "Casual eatery for seafood, including boils featuring crab, shrimp and clams, plus cocktails and beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a074-7466-8b32-a46c60244375.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a074-7466-8b32-a46c60244375",
        "storage_key": "property/5722559043600384/019f1514-a074-7466-8b32-a46c60244375.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.oceancrabhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9741076603917766318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ocean-crab-house",
      "poi_latitude": "37.443288",
      "poi_longitude": "-77.4747347",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-743-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6w_oZsNsYkRrg5jko9BL4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_fe879d2a992d47f025c259f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "8121 Midlothian Turnpike, Richmond, VA 23235, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a226-775b-83eb-014e32d01cd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a226-775b-83eb-014e32d01cd3",
        "storage_key": "property/5722559043600384/019f1514-a226-775b-83eb-014e32d01cd3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/8121-midlothian-turnpike-richmond-va-23235/storeid=2706?WT.mc_id=LS_GOOGLE_FS_2706",
      "poi_directions_map_url": "https://maps.google.com/?cid=11813654329473252253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "37.4966819",
      "poi_longitude": "-77.5459372",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-560-9481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9z2pMIgTsYkRnTuCbwWI8qM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_29b97e8b48f5520c421948dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "7000 Tim Price Way, North Chesterfield, VA 23225, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a078-7698-93c7-ecf7f78f9a46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a078-7698-93c7-ecf7f78f9a46",
        "storage_key": "property/5722559043600384/019f1514-a078-7698-93c7-ecf7f78f9a46.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/va/north-chesterfield/stonebridge/029/00514?cid=loc_02900514_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2698373583815729283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "37.49881",
      "poi_longitude": "-77.5254394",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-772-8540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-aff9-7368-94c3-2dccf5771109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-aff9-7368-94c3-2dccf5771109",
        "storage_key": "property/5722559043600384/019f1512-aff9-7368-94c3-2dccf5771109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0EZRY4SsYkRg2CiVnqMciU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_0ad0c4026acb0c137fcdd875",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2410 Sheila Ln, Richmond, VA 23225, USA",
      "poi_short_description": "Vast chain of general retailers: offering groceries, clothing, electronics, hardware, home goods, toys, sporting goods, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a5fc-7306-adb3-282607746d16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a5fc-7306-adb3-282607746d16",
        "storage_key": "property/5722559043600384/019f1514-a5fc-7306-adb3-282607746d16.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2821-richmond-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6792109250055986809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "37.5324683",
      "poi_longitude": "-77.53213170000001",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-320-6991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b002-73ed-8a6e-07cf8d424a70",
        "storage_key": "property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEWcTshsTsYkReV47dWBrQl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_684629794557241935e53d3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "7319 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a85a-7088-a728-c904539c02aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a85a-7088-a728-c904539c02aa",
        "storage_key": "property/5722559043600384/019f1514-a85a-7088-a728-c904539c02aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/va/richmond/7319-forest-hill-avenue/fc64",
      "poi_directions_map_url": "https://maps.google.com/?cid=10337911520563774235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "37.5365",
      "poi_longitude": "-77.5309",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-aff9-7368-94c3-2dccf5771109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-aff9-7368-94c3-2dccf5771109",
        "storage_key": "property/5722559043600384/019f1512-aff9-7368-94c3-2dccf5771109.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWWEXRoTsYkRG0OfXsGjd48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_8be72fd05969ede5b28d0be1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7107 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a5ae-77bd-88ff-52dc04cc95f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a5ae-77bd-88ff-52dc04cc95f6",
        "storage_key": "property/5722559043600384/019f1514-a5ae-77bd-88ff-52dc04cc95f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/forest-hill/1931",
      "poi_directions_map_url": "https://maps.google.com/?cid=15922425526004970616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "37.5349753",
      "poi_longitude": "-77.527658",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-330-7365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b002-73ed-8a6e-07cf8d424a70",
        "storage_key": "property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx2L91AQTsYkReHQjwKfR99w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_4e5620291682a6b74c9a3c80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "121 Turner Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a727-719c-bd8b-894b48c99ae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a727-719c-bd8b-894b48c99ae2",
        "storage_key": "property/5722559043600384/019f1514-a727-719c-bd8b-894b48c99ae2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/va/richmond/121-turner-rd-23724?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9503176459675284029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "37.4972772",
      "poi_longitude": "-77.5360342",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-276-9258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-e936-71a0-8882-4b8774f115e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-e936-71a0-8882-4b8774f115e6",
        "storage_key": "property/5722559043600384/019f1514-e936-71a0-8882-4b8774f115e6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJw6_0nZcSsYkRPbLM3KMQ4oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_490161d7b865deac173976cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Sheetz",
      "poi_type": "Shopping & Retail",
      "poi_address": "2911 Hathaway Rd, Richmond, VA 23225, USA",
      "poi_short_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_long_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a8bc-7091-ad59-92a2094e0071.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a8bc-7091-ad59-92a2094e0071",
        "storage_key": "property/5722559043600384/019f1514-a8bc-7091-ad59-92a2094e0071.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://orders.sheetz.com/findASheetz/store/775",
      "poi_directions_map_url": "https://maps.google.com/?cid=15092097571100986174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheetz",
      "poi_latitude": "37.5386404",
      "poi_longitude": "-77.5194022",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-562-9117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-e936-71a0-8882-4b8774f115e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-e936-71a0-8882-4b8774f115e6",
        "storage_key": "property/5722559043600384/019f1514-e936-71a0-8882-4b8774f115e6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJFTw-3cQTsYkRPosCkcfmcdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_3043b00d916a77ceecad5610",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chesterfield Towne Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "11500 Midlothian Turnpike, Richmond, VA 23235, USA",
      "poi_short_description": "Sprawling shopping complex offering more than 100 retailers, plus restaurants & snack shops.",
      "poi_long_description": "Sprawling shopping complex offering more than 100 retailers, plus restaurants & snack shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-67cd-75c9-b361-d281e218bade.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-67cd-75c9-b361-d281e218bade",
        "storage_key": "property/5722559043600384/019f1512-67cd-75c9-b361-d281e218bade.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chesterfieldcenter.com/en?cmpid=lc_yext_yext_other_o_none&utm_medium=local&utm_source=other&utm_content=none",
      "poi_directions_map_url": "https://maps.google.com/?cid=7803157530636599063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterfield-towne-center",
      "poi_latitude": "37.5086181",
      "poi_longitude": "-77.609051",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-794-4662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b002-73ed-8a6e-07cf8d424a70",
        "storage_key": "property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYS5n751tsYkRFz8CZG5iSmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_d9502eaefc8b5d809f7836a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chesterfield Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "1257 Carmia Way, North Chesterfield, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a9dc-70e2-8dd2-4d4d7d094421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a9dc-70e2-8dd2-4d4d7d094421",
        "storage_key": "property/5722559043600384/019f1514-a9dc-70e2-8dd2-4d4d7d094421.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14484231858805010530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterfield-marketplace",
      "poi_latitude": "37.5092798",
      "poi_longitude": "-77.60277909999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7iizp1tsYkRYvB3hCJUAsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_a31bd22c2a190373ca539a09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1386 Carmia Way, Richmond, VA 23235, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a9ec-76ef-9255-15483a2ad110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a9ec-76ef-9255-15483a2ad110",
        "storage_key": "property/5722559043600384/019f1514-a9ec-76ef-9255-15483a2ad110.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "https://www.homedepot.com/l/Midlothian/VA/Richmond/23235/4631?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6986950019272982579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.5105907",
      "poi_longitude": "-77.6037234",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-897-9021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b002-73ed-8a6e-07cf8d424a70",
        "storage_key": "property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVVVVZFysYkRM8AsKgai9mA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_4b6ddd5be0836287969d284a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "LeafSpring School at the Boulders",
      "poi_type": "Education",
      "poi_address": "7421 Boulder Springs Dr, North Chesterfield, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b1a8-747c-8a2f-6a8f78df284b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b1a8-747c-8a2f-6a8f78df284b",
        "storage_key": "property/5722559043600384/019f1514-b1a8-747c-8a2f-6a8f78df284b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.leafspringschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751898399128946108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leafspring-school-at-the-boulders",
      "poi_latitude": "37.5030813",
      "poi_longitude": "-77.53345279999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 804-207-8272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5977dpQSsYkRvAXoWIppW_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_da1b1882b9cd167ad226b836",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Crestwood Elementary School",
      "poi_type": "Education",
      "poi_address": "7600 Whittington Dr, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://crestwoodes.oneccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2183702729382104665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crestwood-elementary-school",
      "poi_latitude": "37.5261377",
      "poi_longitude": "-77.5372212",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-560-2710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk3x-R-ASsYkRWQ7fBxASTh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d7e0e0621ac82fbbbb363051",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Providence Middle School",
      "poi_type": "Education",
      "poi_address": "900 Starlight Ln, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-ada8-7438-8672-bf83ed29bb78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-ada8-7438-8672-bf83ed29bb78",
        "storage_key": "property/5722559043600384/019f1514-ada8-7438-8672-bf83ed29bb78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.oneccps.org/pvms/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4514848741419750689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-middle-school",
      "poi_latitude": "37.4883187",
      "poi_longitude": "-77.54289299999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-674-1355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkRcY1KASsYkRIZXxdgL3pz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_89a2c9275c9d2b81ef6c4eab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "James River High School",
      "poi_type": "Education",
      "poi_address": "3700 James River Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-ad3d-70bd-bf79-36cc4ad80926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-ad3d-70bd-bf79-36cc4ad80926",
        "storage_key": "property/5722559043600384/019f1514-ad3d-70bd-bf79-36cc4ad80926.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://jamesriverhs.oneccps.org/o/jrhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=2057786195779466517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-river-high-school",
      "poi_latitude": "37.552284",
      "poi_longitude": "-77.649329",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-378-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWcqhQiZssYkRFTUjd6S5jhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_65b84ae6989c20b835e4a666",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Bon Air Elementary School",
      "poi_type": "Education",
      "poi_address": "8701 Polk St, Bon Air, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b1bb-7675-99e3-7fe99eeebb4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b1bb-7675-99e3-7fe99eeebb4e",
        "storage_key": "property/5722559043600384/019f1514-b1bb-7675-99e3-7fe99eeebb4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bonaires.oneccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9478060102764925366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-air-elementary-school",
      "poi_latitude": "37.5285301",
      "poi_longitude": "-77.5628251",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-560-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqdzanCoTsYkRthEbUXLViIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1684379b6372860e65d842b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Huguenot High School",
      "poi_type": "Education",
      "poi_address": "7945 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b120-7550-b530-61bc8279a146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b120-7550-b530-61bc8279a146",
        "storage_key": "property/5722559043600384/019f1514-b120-7550-b530-61bc8279a146.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://hhs.rvaschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11119870295197413264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huguenot-high-school",
      "poi_latitude": "37.5323924",
      "poi_longitude": "-77.54257559999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-320-7967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLx5j-SATsYkRkO-oLR63UZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_a677628111ddd24a52266c63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Greenfield Elementary School",
      "poi_type": "Education",
      "poi_address": "10751 Savoy Rd, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://greenfieldes.oneccps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2746347301942140604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenfield-elementary-school",
      "poi_latitude": "37.5187821",
      "poi_longitude": "-77.5918087",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-560-2720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuRZDXhFtsYkRvB4dAlL8HCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_777e62a238863d6b3ec2664d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Brightpoint Community College",
      "poi_type": "Education",
      "poi_address": "13101 US-1, Chester, VA 23831, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b3b3-74b9-b6c3-6d692e0c0d52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b3b3-74b9-b6c3-6d692e0c0d52",
        "storage_key": "property/5722559043600384/019f1514-b3b3-74b9-b6c3-6d692e0c0d52.webp",
        "width": 1280,
        "height": 751
      },
      "poi_business_url": "https://www.brightpoint.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7952250248163053409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brightpoint-community-college",
      "poi_latitude": "37.3459689",
      "poi_longitude": "-77.4079141",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 18 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 804-796-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjTUaZTAJsYkRYU_FxncRXG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_009fe8b94ac3974c669c462c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Buford Road Christian Academy",
      "poi_type": "Education",
      "poi_address": "819 Buford Rd, Richmond, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-bb80-7050-9dba-87548ca36cde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-bb80-7050-9dba-87548ca36cde",
        "storage_key": "property/5722559043600384/019f1514-bb80-7050-9dba-87548ca36cde.webp",
        "width": 1280,
        "height": 726
      },
      "poi_business_url": "https://brcapatriots.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15665411140919445875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buford-road-christian-academy",
      "poi_latitude": "37.5100596",
      "poi_longitude": "-77.5510271",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 804-323-0197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe3QqdMgSsYkRc0nzCm-4Ztk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_041453a14ad2877982c57bb3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "University of Richmond",
      "poi_type": "Education",
      "poi_address": "410 Westhampton Way, Richmond, VA 23173, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-70de-771a-b21a-c340ef8da6c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-70de-771a-b21a-c340ef8da6c2",
        "storage_key": "property/5722559043600384/019f1512-70de-771a-b21a-c340ef8da6c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.richmond.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3533409872184270335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-richmond",
      "poi_latitude": "37.5758243",
      "poi_longitude": "-77.5397192",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-289-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtXlSJ6IUsYkR_91m1Y4xCTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_acab15ede1bc8edc7e4e6eb4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Sunday Park (Private)",
      "poi_type": "Entertainment",
      "poi_address": "4604 Millridge Pkwy, Midlothian, VA 23112, USA",
      "poi_short_description": "Scenic park with a playground, walking trails and water views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b46a-71ff-b46b-715cbe34a04d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b46a-71ff-b46b-715cbe34a04d",
        "storage_key": "property/5722559043600384/019f1514-b46a-71ff-b46b-715cbe34a04d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12807679692780105345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunday-park-private",
      "poi_latitude": "37.4222541",
      "poi_longitude": "-77.6486595",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-744-1035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh57kOPtzsYkRgW4kldIEvrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_52471356290ead6d6b9b3453",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "The Boathouse at Sunday Park",
      "poi_type": "Entertainment",
      "poi_address": "4602 Millridge Pkwy, Midlothian, VA 23112, USA",
      "poi_short_description": "Indoor-outdoor waterfront spot for American fare & seafood plus house drinks & a full bar.",
      "poi_long_description": "Indoor-outdoor waterfront spot for American fare & seafood plus house drinks & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-bbe0-72cc-a10a-fba23ea9086a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-bbe0-72cc-a10a-fba23ea9086a",
        "storage_key": "property/5722559043600384/019f1514-bbe0-72cc-a10a-fba23ea9086a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.theboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17296790857481601596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boathouse-at-sunday-park",
      "poi_latitude": "37.4223955",
      "poi_longitude": "-77.6487215",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-744-2545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-afbb-722c-9369-e6c99cf41d1d",
        "storage_key": "property/5722559043600384/019f1512-afbb-722c-9369-e6c99cf41d1d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYYAmvxzsYkRPEJqfqSLCvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_f4ece52fcb3ff8cf26c81a83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Uptown Alley Richmond",
      "poi_type": "Entertainment",
      "poi_address": "6101 Brad McNeer Pkwy, Midlothian, VA 23112, USA",
      "poi_short_description": "Bowling on high-tech lanes with HDTVs & auto-scoring plus video games & a lounge with live music.",
      "poi_long_description": "Bowling on high-tech lanes with HDTVs & auto-scoring plus video games & a lounge with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b7f0-7773-aa25-c7ba541b963c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b7f0-7773-aa25-c7ba541b963c",
        "storage_key": "property/5722559043600384/019f1514-b7f0-7773-aa25-c7ba541b963c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://uptownalleyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14387089604994820017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-alley-richmond",
      "poi_latitude": "37.415809",
      "poi_longitude": "-77.6284582",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 44 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-744-1077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCY5AcotzsYkRsWduCcU1qcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_2f0a6676eeb8ff08b9b2694f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Regal Commonwealth",
      "poi_type": "Entertainment",
      "poi_address": "5001 Commonwealth Centre Pkwy, Midlothian, VA 23112, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b5fa-704d-8a43-34a39263a6c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b5fa-704d-8a43-34a39263a6c1",
        "storage_key": "property/5722559043600384/019f1514-b5fa-704d-8a43-34a39263a6c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-commonwealth-1864?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4686176534163867604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-commonwealth",
      "poi_latitude": "37.41944",
      "poi_longitude": "-77.62887599999999",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 49 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-e947-7161-8a1c-bf5fb0265484.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-e947-7161-8a1c-bf5fb0265484",
        "storage_key": "property/5722559043600384/019f1514-e947-7161-8a1c-bf5fb0265484.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUwv5IxzsYkR1MebubqkCEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a34687907483dada6970aa4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Robious Landing Park",
      "poi_type": "Entertainment",
      "poi_address": "3800 James River Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "Well-maintained trails, a boat launch and a dock for canoeing and kayaking along the James River.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b7e8-71ca-b3e2-8caea3f5fb62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b7e8-71ca-b3e2-8caea3f5fb62",
        "storage_key": "property/5722559043600384/019f1514-b7e8-71ca-b3e2-8caea3f5fb62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chesterfield.gov/150/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9898839394627477067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robious-landing-park",
      "poi_latitude": "37.5576841",
      "poi_longitude": "-77.650033",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-748-1623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYIr4iBssYkRS95prfu9X4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_cdeda839b2de6bbf4eb9683c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Midlothian Mines Park",
      "poi_type": "Entertainment",
      "poi_address": "13301 N Woolridge Rd, Midlothian, VA 23114, USA",
      "poi_short_description": "Park featuring a lake and coal-mine history, along with walking trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b84a-7399-8e85-8ce6469079a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b84a-7399-8e85-8ce6469079a7",
        "storage_key": "property/5722559043600384/019f1514-b84a-7399-8e85-8ce6469079a7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.midlomines.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10470582146648821722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midlothian-mines-park",
      "poi_latitude": "37.4950322",
      "poi_longitude": "-77.6428596",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-796-7075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY7T3HAZysYkR2s-Movz6TpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f4eb4ffc4819da389f3e9004",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Pocahontas State Park",
      "poi_type": "Entertainment",
      "poi_address": "10301 E State Pk Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_long_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-be25-723d-851d-dbd1c8a97603.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-be25-723d-851d-dbd1c8a97603",
        "storage_key": "property/5722559043600384/019f1514-be25-723d-851d-dbd1c8a97603.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dcr.virginia.gov/state-parks/pocahontas.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=450592607913044015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pocahontas-state-park",
      "poi_latitude": "37.3724285",
      "poi_longitude": "-77.57153199999999",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 804-796-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2SslsB0sYkRL-gS7ZbTQAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_5571bd7c86623180c24ae07b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chesterfield County Museum",
      "poi_type": "Entertainment",
      "poi_address": "6813 Mimms Loop, Chesterfield, VA 23832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-bef1-7318-998c-665f1782d9ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-bef1-7318-998c-665f1782d9ee",
        "storage_key": "property/5722559043600384/019f1514-bef1-7318-998c-665f1782d9ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chesterfield.gov/facilities/facility/details/Chesterfield-County-Museum-86",
      "poi_directions_map_url": "https://maps.google.com/?cid=9438513300368654480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterfield-county-museum",
      "poi_latitude": "37.37695",
      "poi_longitude": "-77.50690259999999",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-768-7311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b068-7472-9cbc-204d6fe4b951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b068-7472-9cbc-204d6fe4b951",
        "storage_key": "property/5722559043600384/019f1512-b068-7472-9cbc-204d6fe4b951.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqTUXmaILsYkRkABG3NZV_II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_b0cbe6ade7d13a422151d011",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Children's Museum Chesterfield",
      "poi_type": "Entertainment",
      "poi_address": "6629 Lake Harbour Dr, Midlothian, VA 23112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c40f-717c-911d-2fbaa6cfc94e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c40f-717c-911d-2fbaa6cfc94e",
        "storage_key": "property/5722559043600384/019f1514-c40f-717c-911d-2fbaa6cfc94e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmorva.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17384345003090798417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-chesterfield",
      "poi_latitude": "37.4048067",
      "poi_longitude": "-77.6736348",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 39 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-474-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b010-7610-98d6-a4916a8feb52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b010-7610-98d6-a4916a8feb52",
        "storage_key": "property/5722559043600384/019f1512-b010-7610-98d6-a4916a8feb52.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJT194Krh2sYkRUWcQkqyZQfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_afaa4d124a2126407da25b21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "The Broadberry",
      "poi_type": "Entertainment",
      "poi_address": "2729 W Broad St, Richmond, VA 23220, USA",
      "poi_short_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_long_description": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-bef2-73bb-91ab-ca76413bd39c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-bef2-73bb-91ab-ca76413bd39c",
        "storage_key": "property/5722559043600384/019f1514-bef2-73bb-91ab-ca76413bd39c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebroadberry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6871247635338204732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadberry",
      "poi_latitude": "37.5616733",
      "poi_longitude": "-77.4695045",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-353-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJizauXFURsYkRPJYTpFGTW18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_d18e60646c805dc7e799df55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c08d-719e-87e5-f9fb86f04981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c08d-719e-87e5-f9fb86f04981",
        "storage_key": "property/5722559043600384/019f1514-c08d-719e-87e5-f9fb86f04981.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b083-72af-8119-e3699fe17d3f",
        "storage_key": "property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_9747ff0c8fd96cbcc03f3e93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9211 Burge Ave, Richmond, VA 23237, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c356-743e-a0bd-9d296ef91825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c356-743e-a0bd-9d296ef91825",
        "storage_key": "property/5722559043600384/019f1514-c356-743e-a0bd-9d296ef91825.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=17029623493614206113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "37.4001647",
      "poi_longitude": "-77.4221799",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 804-275-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJafGG1ycPsYkRoXyFM1dgVew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_bd8c165502df594a409fb1a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Bon Secours Urgent Care, Swift Creek",
      "poi_type": "Health and Wellness",
      "poi_address": "14426 Hull Street Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c2f8-70ea-86c8-80f36a4950eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c2f8-70ea-86c8-80f36a4950eb",
        "storage_key": "property/5722559043600384/019f1514-c2f8-70ea-86c8-80f36a4950eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bonsecours.com/locations/walk-in-urgent-care/richmond/bon-secours-urgent-care-swift-creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=2322083984187056299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-urgent-care-swift-creek",
      "poi_latitude": "37.4044309",
      "poi_longitude": "-77.6764503",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-877-8322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdcsxKSd3sYkRq-AXqBSzOSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_8a69217a9c2f467fe3b7e025",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5001 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c554-749b-80e9-26670c0f1044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c554-749b-80e9-26670c0f1044",
        "storage_key": "property/5722559043600384/019f1514-c554-749b-80e9-26670c0f1044.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/richmond-va-pharmacies/5001-forest-hill-avenue-richmond-va-23225/storeid=1989?WT.mc_id=LS_GOOGLE_RX_1989",
      "poi_directions_map_url": "https://maps.google.com/?cid=12691097514468981491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.5218034",
      "poi_longitude": "-77.4890628",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-232-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-e937-71a8-823a-f119b1d548f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-e937-71a8-823a-f119b1d548f9",
        "storage_key": "property/5722559043600384/019f1514-e937-71a8-823a-f119b1d548f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyybWwDQSsYkR8zrE9_LVH7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d45201385822c753dc850b34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1214 Westover Hills Blvd, Richmond, VA 23225, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c9b3-770f-b4cd-d50640349916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c9b3-770f-b4cd-d50640349916",
        "storage_key": "property/5722559043600384/019f1514-c9b3-770f-b4cd-d50640349916.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1214+westover+hills+blvd-richmond-va-23225/id=3681",
      "poi_directions_map_url": "https://maps.google.com/?cid=5107526904815324487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "37.5206506",
      "poi_longitude": "-77.4892437",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 804-230-6335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9XM7jTQSsYkRR41EuqiU4UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_ef588708484c9bd0dc67642b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4020 Meadowdale Blvd, Richmond, VA 23234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-7e07-7182-91fc-07676966846d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-7e07-7182-91fc-07676966846d",
        "storage_key": "property/5722559043600384/019f1512-7e07-7182-91fc-07676966846d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/richmond-north-chesterfield-va?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=267477607157941067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.4386626",
      "poi_longitude": "-77.4684426",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-554-5455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0usY4gPsYkRS0MFcHdFtgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_ca7ec274869e56edd01abbbd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7101 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Chain fitness center offering a range of equipment, personal training, and 24/7 access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c9e3-742e-a2af-b6cf76ca2aef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c9e3-742e-a2af-b6cf76ca2aef",
        "storage_key": "property/5722559043600384/019f1514-c9e3-742e-a2af-b6cf76ca2aef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/richmond-virginia-3652/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3652",
      "poi_directions_map_url": "https://maps.google.com/?cid=14493859207698867019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "37.5346358",
      "poi_longitude": "-77.52650229999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 804-404-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWBI3gQTsYkRS2NqWyiIJMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ae66a21f059e6cf993f05a54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Manchester Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "7540 Hull St, Richmond, VA 23235, USA",
      "poi_short_description": "Family-friendly gym featuring exercise machines, cardio equipment, a pool and fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-7da9-724b-a0d7-2d9e7c56264c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-7da9-724b-a0d7-2d9e7c56264c",
        "storage_key": "property/5722559043600384/019f1512-7da9-724b-a0d7-2d9e7c56264c.webp",
        "width": 768,
        "height": 432
      },
      "poi_business_url": "https://www.ymcarichmond.org/locations/manchester-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=13703487378888870281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manchester-family-ymca",
      "poi_latitude": "37.4700616",
      "poi_longitude": "-77.5330223",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 804-276-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT4LDWwNsYkRiUm4uiqRLL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_8ac7b191697abe038965820f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Coconut Elephant Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "825 Grove Rd Ste 12, Midlothian, VA 23114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-caa6-7729-ab72-3babe5abb252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-caa6-7729-ab72-3babe5abb252",
        "storage_key": "property/5722559043600384/019f1514-caa6-7729-ab72-3babe5abb252.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "http://www.coconutelephantyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3513103920825741976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coconut-elephant-yoga",
      "poi_latitude": "37.5027727",
      "poi_longitude": "-77.6144126",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-305-2297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9063adZzsYkRmLLZG2cNwTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_6c0fbb5d62cc09f4a93f313a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "VCU Health Hayes E. Willis Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4730 E Southside Plaza, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-ce9d-757c-b280-9262d35d4403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-ce9d-757c-b280-9262d35d4403",
        "storage_key": "property/5722559043600384/019f1514-ce9d-757c-b280-9262d35d4403.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.vcuhealth.org/locations/location-details?practice=15",
      "poi_directions_map_url": "https://maps.google.com/?cid=15948500748181456686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vcu-health-hayes-e-willis-health-center",
      "poi_latitude": "37.502168",
      "poi_longitude": "-77.478354",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-230-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCeGvJCISsYkRLkdog-50VN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e6aa1f738bf2f7bfb86703da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Rockwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 Courthouse Rd, Richmond, VA 23236, USA",
      "poi_short_description": "Public green space with archery, softball, basketball & tennis plus a playground, trail & dog park.",
      "poi_long_description": "Public green space with archery, softball, basketball & tennis plus a playground, trail & dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-8763-76ce-b400-8252404a0ec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-8763-76ce-b400-8252404a0ec2",
        "storage_key": "property/5722559043600384/019f1512-8763-76ce-b400-8252404a0ec2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chesterfield.gov/3824/Rockwood-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14436087448396485264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockwood-park",
      "poi_latitude": "37.4481749",
      "poi_longitude": "-77.5823319",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-276-6661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2GKft9ysYkRkNIldAxJV8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2bf9a147d736699d7c0ce054",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Huguenot Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10901 Robious Rd, Richmond, VA 23235, USA",
      "poi_short_description": "53-acred wooded park featuring a play lot, sports fields, basketball & tennis courts, trails & more.",
      "poi_long_description": "53-acred wooded park featuring a play lot, sports fields, basketball & tennis courts, trails & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-cc7b-738f-8d46-c8aca76a51c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-cc7b-738f-8d46-c8aca76a51c3",
        "storage_key": "property/5722559043600384/019f1514-cc7b-738f-8d46-c8aca76a51c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chesterfield.gov/Facilities/Facility/Details/Huguenot-Park-53",
      "poi_directions_map_url": "https://maps.google.com/?cid=7984569737700845474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huguenot-park",
      "poi_latitude": "37.5148538",
      "poi_longitude": "-77.5985965",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 804-748-1892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTUKag1tsYkRoif-U9_jzm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_08e248a92f2a88577b88f2d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Robious Landing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3800 James River Rd, Midlothian, VA 23113, USA",
      "poi_short_description": "Well-maintained trails, a boat launch and a dock for canoeing and kayaking along the James River.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-b7e8-71ca-b3e2-8caea3f5fb62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-b7e8-71ca-b3e2-8caea3f5fb62",
        "storage_key": "property/5722559043600384/019f1514-b7e8-71ca-b3e2-8caea3f5fb62.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chesterfield.gov/150/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9898839394627477067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robious-landing-park",
      "poi_latitude": "37.5576841",
      "poi_longitude": "-77.650033",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 804-748-1623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYIr4iBssYkRS95prfu9X4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4e792232a355536c3893eceb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "River City Sportsplex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13030 Genito Rd, Midlothian, VA 23112, USA",
      "poi_short_description": "Facility offering multiple sports fields, plus concerts, and adequate parking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-cf02-70b1-aa06-5b19773ac32d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-cf02-70b1-aa06-5b19773ac32d",
        "storage_key": "property/5722559043600384/019f1514-cf02-70b1-aa06-5b19773ac32d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rivercitysportsplex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9671931019467510844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-city-sportsplex",
      "poi_latitude": "37.4543345",
      "poi_longitude": "-77.63443099999999",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-748-1623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdbi0MpzsYkRPFRxowSaOYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_91fb44597f9c4a5b64f71d22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Forest Hill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4021 Forest Hill Ave, Richmond, VA 23225, USA",
      "poi_short_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_long_description": "Partial wetland area with a historic home, nature trails, wildlife, tennis courts, picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-950d-76ae-8180-347bba00a407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-950d-76ae-8180-347bba00a407",
        "storage_key": "property/5722559043600384/019f1512-950d-76ae-8180-347bba00a407.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rva.gov/parks-recreation/forest-hill-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4852190897879243188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-hill-park",
      "poi_latitude": "37.5207992",
      "poi_longitude": "-77.4763246",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-646-0036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ1A5CoSsYkRtNl54ulxVkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b936f43ab221f172c4ad61f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "James River Park Pony Pasture",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Richmond, VA 23225, USA",
      "poi_short_description": "Riverside park featuring scenic trails for biking and hiking, as well as swimming.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-d0f0-74ed-9c00-765c4512d1f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-d0f0-74ed-9c00-765c4512d1f3",
        "storage_key": "property/5722559043600384/019f1514-d0f0-74ed-9c00-765c4512d1f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jamesriverpark.org/explore-the-park-pony-pasture/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12267777557924412234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-river-park-pony-pasture",
      "poi_latitude": "37.5506636",
      "poi_longitude": "-77.51756619999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgXjOv3UTsYkRSvuXA7HmP6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_166701229e61cb5f1f7e0e88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Belle Isle",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Belle Isle, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-cfc8-74a8-bdbf-50b9791ea60d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-cfc8-74a8-bdbf-50b9791ea60d",
        "storage_key": "property/5722559043600384/019f1514-cfc8-74a8-bdbf-50b9791ea60d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12144418279497473606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belle-isle",
      "poi_latitude": "37.5289519",
      "poi_longitude": "-77.45286",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUJYAnIRsYkRRh410RSkiag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_9da651a25f53a02060138ff9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Pocahontas State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10301 E State Pk Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_long_description": "An 8,000-acre park offering hiking, biking & horse trails, plus 2 fishing lakes & an aquatic center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-be25-723d-851d-dbd1c8a97603.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-be25-723d-851d-dbd1c8a97603",
        "storage_key": "property/5722559043600384/019f1514-be25-723d-851d-dbd1c8a97603.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dcr.virginia.gov/state-parks/pocahontas.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=450592607913044015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pocahontas-state-park",
      "poi_latitude": "37.3724285",
      "poi_longitude": "-77.57153199999999",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 804-796-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2SslsB0sYkRL-gS7ZbTQAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_96e894e6f72154cda493d0e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Lakeview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "503 Lake Ave, Colonial Heights, VA 23834, USA",
      "poi_short_description": "Kid-friendly park for activities like fishing and kayaking plus a playground and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-d5b3-7598-8810-d4088c356493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-d5b3-7598-8810-d4088c356493",
        "storage_key": "property/5722559043600384/019f1514-d5b3-7598-8810-d4088c356493.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.colonialheightsva.gov/Facilities/Facility/Details/Lakeview-Park-35",
      "poi_directions_map_url": "https://maps.google.com/?cid=18031309248846337418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeview-park",
      "poi_latitude": "37.2701041",
      "poi_longitude": "-77.4188384",
      "poi_miles_from_property": "21.8 mi",
      "poi_walking_minutes": "7 hours 59 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 804-520-9392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-Lb0q6nsYkRipWzVDoUPPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_49ef387a2422104d09a35c74",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Maymont",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1700 Hampton St, Richmond, VA 23220, USA",
      "poi_short_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_long_description": "A 19th-century estate hosting events & tours of its Gilded Age mansion, gardens & wildlife center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-857a-700f-b451-ae205f680dc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-857a-700f-b451-ae205f680dc6",
        "storage_key": "property/5722559043600384/019f1512-857a-700f-b451-ae205f680dc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://maymont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4834827198225545156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maymont",
      "poi_latitude": "37.5341784",
      "poi_longitude": "-77.474571",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-525-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b072-768b-8ed9-a08abd613953",
        "storage_key": "property/5722559043600384/019f1512-b072-768b-8ed9-a08abd613953.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8TfDdkTsYkRxHehhLjBGEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e656dcb0dcf65b3f5f51c0c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Richmond International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Richard E Byrd Terminal Dr, Richmond, VA 23250, USA",
      "poi_short_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_long_description": "Opened in 1927, this airport close to Virginia's capital offers free WiFi & mostly domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-d66d-74ee-93cc-bff541570450.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-d66d-74ee-93cc-bff541570450",
        "storage_key": "property/5722559043600384/019f1514-d66d-74ee-93cc-bff541570450.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyrichmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6449714593814021840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-international-airport",
      "poi_latitude": "37.5105562",
      "poi_longitude": "-77.3266991",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 804-226-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-e936-71a0-8882-4cdb2be7c1f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-e936-71a0-8882-4cdb2be7c1f5",
        "storage_key": "property/5722559043600384/019f1514-e936-71a0-8882-4cdb2be7c1f5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dzDsqwbsYkR0AbwQkD9gVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_4d7d14f01a28dee1175a161b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Richmond Staples Mill Road",
      "poi_type": "Transportation & Transit",
      "poi_address": "7519 Staples Mill Rd, Richmond, VA 23228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-d355-76be-9b55-3b413c5732ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-d355-76be-9b55-3b413c5732ec",
        "storage_key": "property/5722559043600384/019f1514-d355-76be-9b55-3b413c5732ec.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvr",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387222506202384095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-staples-mill-road",
      "poi_latitude": "37.6177745",
      "poi_longitude": "-77.49697019999999",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubZoY7cVsYkR38YuoFNCw0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_a253183003f2439eac6e6662",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Richmond Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1500 E Main St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-d66c-74ce-8ce7-82d47090d295.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-d66c-74ce-8ce7-82d47090d295",
        "storage_key": "property/5722559043600384/019f1514-d66c-74ce-8ce7-82d47090d295.webp",
        "width": 1280,
        "height": 1237
      },
      "poi_business_url": "https://www.amtrak.com/stations/rvm.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11973413221483929113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-main-street-station",
      "poi_latitude": "37.5351005",
      "poi_longitude": "-77.4287069",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8r0xR4RsYkRGd6DF-MbKqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_02dd1483dee958e3745465d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "GRTC",
      "poi_type": "Transportation & Transit",
      "poi_address": "301 E Belt Blvd, Richmond, VA 23224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-d6c6-721d-9a17-5d3ed52e79b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-d6c6-721d-9a17-5d3ed52e79b5",
        "storage_key": "property/5722559043600384/019f1514-d6c6-721d-9a17-5d3ed52e79b5.webp",
        "width": 1000,
        "height": 380
      },
      "poi_business_url": "http://www.ridegrtc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16451363726910217568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grtc",
      "poi_latitude": "37.5066205",
      "poi_longitude": "-77.478867",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-358-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2E1riESsYkRYN06hSX8TuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_12df98806faa8bf8344b0957",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Midlothian & Chesterfield Towne Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bon Air, VA 23235, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11026934851504211663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midlothian--chesterfield-towne-center",
      "poi_latitude": "37.505738",
      "poi_longitude": "-77.60794899999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0dKYp1tsYkRz4ZIAdOKB5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_bfdd1c0abb7de4b375ce65f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 Walmart Way, Midlothian, VA 23113, USA",
      "poi_short_description": "Department store with a wide range of merchandise, including clothing, electronics, home goods, and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-a5fc-7306-adb3-282607746d16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-a5fc-7306-adb3-282607746d16",
        "storage_key": "property/5722559043600384/019f1514-a5fc-7306-adb3-282607746d16.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1969-midlothian-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4747037045524142073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "37.5042048",
      "poi_longitude": "-77.6296981",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 804-378-9001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b002-73ed-8a6e-07cf8d424a70",
        "storage_key": "property/5722559043600384/019f1512-b002-73ed-8a6e-07cf8d424a70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVVVVUVusYkR-RcWwgrd4EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_79d0ca4289fcadbb0f575b52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Willow Lawn Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Virginia 23230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-dbf8-7661-9f80-cbfa2ee04003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-dbf8-7661-9f80-cbfa2ee04003",
        "storage_key": "property/5722559043600384/019f1514-dbf8-7661-9f80-cbfa2ee04003.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3072887149338080283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-lawn-station",
      "poi_latitude": "37.58458",
      "poi_longitude": "-77.49725",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-e954-7461-b18b-feb62802c23b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-e954-7461-b18b-feb62802c23b",
        "storage_key": "property/5722559043600384/019f1514-e954-7461-b18b-feb62802c23b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_ACSWoUsYkRG7Qo25QWpSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_ef403538a56a6c503180e61e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chippenham Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7101 Jahnke Rd, Richmond, VA 23225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-c08d-719e-87e5-f9fb86f04981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-c08d-719e-87e5-f9fb86f04981",
        "storage_key": "property/5722559043600384/019f1514-c08d-719e-87e5-f9fb86f04981.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://www.hcavirginia.com/locations/chippenham-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643199243469856749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chippenham-hospital",
      "poi_latitude": "37.5135368",
      "poi_longitude": "-77.5261508",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 804-483-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b083-72af-8119-e3699fe17d3f",
        "storage_key": "property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2uycvASsYkR7R-ObjcZEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_006a85c1403983f073467918",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chesterfield County Govt Ofcs",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9901 Lori Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chesterfield.gov/27/Departments",
      "poi_directions_map_url": "https://maps.google.com/?cid=12063357218050306170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterfield-county-govt-ofcs",
      "poi_latitude": "37.3765559",
      "poi_longitude": "-77.50781429999999",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 804-748-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b068-7472-9cbc-204d6fe4b951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b068-7472-9cbc-204d6fe4b951",
        "storage_key": "property/5722559043600384/019f1512-b068-7472-9cbc-204d6fe4b951.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cCVY6ILsYkRenCItHmnaac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_43103be0bdd934cda245782f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Chesterfield County School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9900 Krause Rd, Chesterfield, VA 23832, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-d9e5-732f-b27f-c7b08700709f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-d9e5-732f-b27f-c7b08700709f",
        "storage_key": "property/5722559043600384/019f1514-d9e5-732f-b27f-c7b08700709f.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://mychesterfieldschools.com/about/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15152764613149258328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterfield-county-school-district",
      "poi_latitude": "37.3766268",
      "poi_longitude": "-77.5036466",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 804-748-1405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0V7TAZcLsYkRWPLeAyJvSdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_513375c832363774bfb159a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "VCU Medical Center Main Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1250 E Marshall St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-80f8-7537-ae6f-38eda70f1c45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-80f8-7537-ae6f-38eda70f1c45",
        "storage_key": "property/5722559043600384/019f1512-80f8-7537-ae6f-38eda70f1c45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vcuhealth.org/locations/location-details?practice=10",
      "poi_directions_map_url": "https://maps.google.com/?cid=16171533531014720203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vcu-medical-center-main-hospital",
      "poi_latitude": "37.5404994",
      "poi_longitude": "-77.4304837",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-828-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b083-72af-8119-e3699fe17d3f",
        "storage_key": "property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHcj3gSERsYkRy2pz5RDUbOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_e779becd66da71e28efd4428",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Virginia Commonwealth University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Richmond, VA 23284, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-6f9d-73bd-96d6-eb70f7282f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-6f9d-73bd-96d6-eb70f7282f22",
        "storage_key": "property/5722559043600384/019f1512-6f9d-73bd-96d6-eb70f7282f22.webp",
        "width": 900,
        "height": 599
      },
      "poi_business_url": "http://vcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1682113867784917192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-commonwealth-university",
      "poi_latitude": "37.5469205",
      "poi_longitude": "-77.45416449999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 804-828-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b005-7608-a84b-8073270f23c4",
        "storage_key": "property/5722559043600384/019f1512-b005-7608-a84b-8073270f23c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_3Le1yMRsYkRyBAUiaYRWBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_43aa40c131219bc15453075a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Bon Secours St. Francis Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13710 St Francis Blvd, Midlothian, VA 23114, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-de46-7411-b880-24042211ac6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-de46-7411-b880-24042211ac6e",
        "storage_key": "property/5722559043600384/019f1514-de46-7411-b880-24042211ac6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/richmond/st-francis-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=5463114148681755778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-st-francis-medical-center",
      "poi_latitude": "37.46677890000001",
      "poi_longitude": "-77.65917809999999",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 37 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 804-594-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b083-72af-8119-e3699fe17d3f",
        "storage_key": "property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzHhB4ZxsYkRgiyWl1_h0Es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_bf67c9eb98984139ad62d41c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Bon Secours St. Mary's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5801 Bremo Rd, Richmond, VA 23226, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-9581-730e-a69d-39bcfa444c89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-9581-730e-a69d-39bcfa444c89",
        "storage_key": "property/5722559043600384/019f1512-9581-730e-a69d-39bcfa444c89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/richmond/st-marys-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=15600236463638216957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-st-marys-hospital",
      "poi_latitude": "37.5834114",
      "poi_longitude": "-77.51238839999999",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 804-285-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b083-72af-8119-e3699fe17d3f",
        "storage_key": "property/5722559043600384/019f1512-b083-72af-8119-e3699fe17d3f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUGmEmEUsYkR_YBA-2gsf9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_4243e9961c50a4359f7abaf5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Altria Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6601 W Broad St, Richmond, VA 23230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-dca6-75ca-805c-0f643ae6dc9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-dca6-75ca-805c-0f643ae6dc9f",
        "storage_key": "property/5722559043600384/019f1514-dca6-75ca-805c-0f643ae6dc9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.altria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14996391984863159021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "altria-headquarters",
      "poi_latitude": "37.60063239999999",
      "poi_longitude": "-77.5167464",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITmtbfgUsYkR7aJIUg7jHdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_b8e1bd0aa24803f914ff931a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Dominion Energy Virginia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "120 Tredegar St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-dfd9-729b-bbd3-492c508c2616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-dfd9-729b-bbd3-492c508c2616",
        "storage_key": "property/5722559043600384/019f1514-dfd9-729b-bbd3-492c508c2616.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dominionenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11041679550737667097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominion-energy-virginia",
      "poi_latitude": "37.533753",
      "poi_longitude": "-77.4537127",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 866-366-4357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b066-707d-b3f3-db8edb82b3d1",
        "storage_key": "property/5722559043600384/019f1512-b066-707d-b3f3-db8edb82b3d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj2CeDWwRsYkRGdRp0QztO5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_37d6f81ffa256cc3e894c9b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "poi_name": "Federal Reserve Bank of Richmond",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 E Byrd St, Richmond, VA 23219, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1514-dcad-721f-95e3-43630ed05c5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-dcad-721f-95e3-43630ed05c5d",
        "storage_key": "property/5722559043600384/019f1514-dcad-721f-95e3-43630ed05c5d.webp",
        "width": 1210,
        "height": 680
      },
      "poi_business_url": "http://www.richmondfed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6660900425225583294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "federal-reserve-bank-of-richmond",
      "poi_latitude": "37.5355285",
      "poi_longitude": "-77.4406827",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 804-697-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f1512-b068-7472-9cbc-204d6fe4b951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-b068-7472-9cbc-204d6fe4b951",
        "storage_key": "property/5722559043600384/019f1512-b068-7472-9cbc-204d6fe4b951.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2VtkBYRsYkRvrrRUaVFcFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    }
  ],
  "office_hours": [
    {
      "id": "custom_d7b849ee-24be-4fe0-baba-886f4d7e6104",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bd50bcfc-c65a-4e13-a7a9-b90fff552996",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1a5eda24-e14a-4ad2-b503-0b17df2712a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b368c22b-54f8-4193-88c2-0760b53b5a49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2ce0528a-cea5-4118-a26a-6569fbb93e08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3fc2f875-7ee9-4b90-9dc7-b3d72c63d351",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_db94f06d-914d-4ae6-b309-6717852f503b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "rating": "5.0",
      "name": "Betsy Wheeler",
      "text": "Very impressive and painless rental process. They were very accommodating to help new renters with challenging financial history find a home. The property and units are clean, modern, with high quality fixtures. Excellent kitchen, closet, and bathroom counter space. If you get Zaria as your leasing agent, you’ll be very happy—she is welcoming, friendly, and super fast to get leasing done. Best leasing agent I’ve worked with ever!",
      "date": "2026-03-07",
      "title": ""
    },
    {
      "id": "custom_ff2c2301-9730-478d-8255-99efebb9b7a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "rating": "5.0",
      "name": "Feeba Koshy",
      "text": "I love living here, we moved recently to this gorgeous, well maintained apartment complex. Both Managers are amazing, very attentive, informative and always looking to hear their clients opionions and implement change accordingly. We have a fur baby that has lots of space to play! There’s a very scenic trial right behind the apartment that we always run on, there's also a bike path! Especially during the Fall the trees surrounding the complex is so serene and beautiful and also provides privacy as well. There’s a lake we like hiking around and we get to see deers and swans!  It’s very easy to live in Boulders Lakeview. It’s safe, pet and family friendly! Highly recommend!\n\nPs- the photos below are all different trials around the apartment complex",
      "date": "2024-02-13",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f17edb3b999ec206c0e76edc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019d02f3-2b59-76bc-991c-a89e42f508c8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with sectional sofa, accent chair, coffee table, and artwork.",
        "public_id": "019d02f3-2b59-76bc-991c-a89e42f508c8",
        "storage_key": "property/5722559043600384/019d02f3-2b59-76bc-991c-a89e42f508c8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR 1BTH, -753 SQFT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xMgeQdMa1Bg"
    }
  ],
  "faqs": [
    {
      "id": "custom_d2816400-a261-41e5-9e66-58f762d3285e",
      "question": "Is Boulders Lakeside pet-friendly?",
      "answer": "Yes. Boulders Lakeside welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (804) 447-4008 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_248e7605-a97a-494e-858f-5c4a004abee0",
      "question": "How can I schedule a tour at Boulders Lakeside?",
      "answer": "You can schedule a tour of Boulders Lakeside online through our Schedule a Tour page, or call the leasing office at (804) 447-4008. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_ac0696c8-dfd8-4189-a33f-ff649633daaf",
      "question": "What are the leasing office hours at Boulders Lakeside?",
      "answer": "The Boulders Lakeside leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (804) 447-4008 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_ce1697a9-a0e7-4e95-8598-08684643bc4e",
      "question": "What floor plans are available at Boulders Lakeside?",
      "answer": "Boulders Lakeside offers 1- and 2-bedroom apartment homes ranging from approximately 740 to 1,156 square feet, across 6 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_72e296b9-a91b-4076-8e8f-3455129dc4d3",
      "question": "What amenities does Boulders Lakeside have?",
      "answer": "Boulders Lakeside offers a range of community and in-home amenities. Community amenities include: American Landmark 360, Chef`s Kitchen, Clubhouse, Dog Wash, Fitness Center, Game Room, Grill Area, Online Resident Services, Pool, Select Homes, Storage Spaces, Cyber Cafe, and Yoga/Flex Studio. In-home features include: hard floors, outside space, tile backsplash, and tubs. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_4a4999ad-5cdc-4756-8e43-2aec408316b4",
      "question": "Where is Boulders Lakeside located?",
      "answer": "Boulders Lakeside is located at 1006 Boulder Lake Ter, North Chesterfield VA 23225. Nearby you'll find dining at Beas Bakery & Deli, shopping at CVS, and green space at Rockwood Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_fc4fb3b1-5cf5-4868-ac72-8ecd4697f65e",
      "question": "How do I apply to live at Boulders Lakeside?",
      "answer": "You can apply to live at Boulders Lakeside online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (804) 447-4008 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_4920cf30-b860-4cf8-9200-2833f54b5938",
      "question": "What do I need to apply at Boulders Lakeside?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Boulders Lakeside leasing team at (804) 447-4008 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_07e1b8d8-692b-4ea7-8cf7-b1a90a1ddd09",
      "question": "What is the Landmark 360 program at Boulders Lakeside?",
      "answer": "Boulders Lakeside participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (804) 447-4008 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_b3775a52-3a6a-45dd-9988-9c648f026e3d",
      "question": "Does Boulders Lakeside have a pool?",
      "answer": "Yes. Boulders Lakeside has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_d7e15a60-d9e0-48e6-b5eb-122a03d61629",
      "question": "Does Boulders Lakeside have a fitness center?",
      "answer": "Yes. Boulders Lakeside has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_ea12406c-d297-4448-8557-50ce033f0d28",
      "question": "Does Boulders Lakeside offer virtual tours?",
      "answer": "Yes. Boulders Lakeside offers virtual tours of 1BR 1BTH, -753 SQFT. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_314020fd-15ef-40bb-a66d-edb20fe4f609",
      "question": "What do residents say about living at Boulders Lakeside?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Boulders Lakeside. One resident wrote: *\"Very impressive and painless rental process. They were very accommodating to help new renters with challenging financial history find a home. The property and units are clean, modern, with high quality fixtures.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_c699b388-0e08-4f1f-a2de-adb80ac15b5b",
      "question": "When was Boulders Lakeside built?",
      "answer": "Boulders Lakeside was built in 2020. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_dd13ba9b-776b-428d-84cf-6cbf6256021b",
      "question": "What is the pet fee at Boulders Lakeside?",
      "answer": "Pets at Boulders Lakeside: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (804) 447-4008 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_35791a34-b587-45dd-8809-fc42ff685e61",
      "question": "What features are included in the apartments at Boulders Lakeside?",
      "answer": "Apartment homes at Boulders Lakeside include hard floors, outside space, tile backsplash, and tubs. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_8c0a002a-07d5-4ffd-a6bc-7aa0bf1a57a2",
      "question": "What restaurants and shops are near Boulders Lakeside?",
      "answer": "Nearby restaurants and shops include Beas Bakery & Deli, LB Cafe 2, Punjab Kitchen Indian Cuisine, and Punjab Kitchen Indian Cuisine. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-2f07-740c-8593-85bcac49b54d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "boulders-lakeside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384"
    },
    {
      "lead_collector_id": "0198aa45-2f6f-76bb-b2bb-3a6853dcc8de",
      "lead_source": "FACEBOOK_ADS",
      "name": "boulders-lakeside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384"
    },
    {
      "lead_collector_id": "0198aa45-2fd2-7038-9511-ec36fccba65f",
      "lead_source": "LANDING_PAGE",
      "name": "boulders-lakeside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-north-chesterfield-va",
      "search_query": "One Bedroom Apartments For Rent In North Chesterfield VA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In North Chesterfield VA",
      "h2_subtitle": "Discover the perfect blend of comfort and convenience at Boulders Lakeside. Our one-bedroom apartments offer modern amenities in a prime location.",
      "page_copy": "Welcome to Boulders Lakeside, where our one bedroom apartments for rent in North Chesterfield VA feature open layouts, premium finishes, and spacious kitchens. Enjoy modern conveniences like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace or take in the views from your patio. Our pet-friendly community is located near Richmond, providing easy access to the best of the area. Experience the perfect getaway to unwind and relax after a busy day. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | One Bedroom Apartments For Rent In North Chesterfield VA",
      "seo_description": "Find one bedroom apartments for rent in North Chesterfield VA at Boulders Lakeside. Enjoy modern amenities and a prime location near Richmond. This is living. This is home.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-north-chesterfield-va",
      "search_query": "Two Bedrooms Apartments For Rent In North Chesterfield VA",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In North Chesterfield VA",
      "h2_subtitle": "Experience spacious living at Boulders Lakeside. Our two-bedroom apartments offer modern amenities and a prime location near Richmond.",
      "page_copy": "Welcome to Boulders Lakeside, where our two bedrooms apartments for rent in North Chesterfield VA feature open layouts, premium finishes, and spacious kitchens. Enjoy modern conveniences like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace or take in the views from your patio. Our pet-friendly community is located near Richmond, providing easy access to the best of the area. Experience the perfect getaway to unwind and relax after a busy day. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Two Bedrooms Apartments For Rent In North Chesterfield VA",
      "seo_description": "Find two bedrooms apartments for rent in North Chesterfield VA at Boulders Lakeside. Enjoy modern amenities and a prime location near Richmond. This is living. This is home.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Enjoy resort-style living at Boulders Lakeside. Our apartments offer modern amenities and a refreshing pool in a prime North Chesterfield location.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent near me with pool offer the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by our refreshing pool, stay active in the fitness center, or unwind in the clubhouse. Located in North Chesterfield near Richmond, Boulders Lakeside provides easy access to the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool at Boulders Lakeside. Enjoy modern amenities, a refreshing pool, and a prime location in North Chesterfield near Richmond.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Stay active and healthy at Boulders Lakeside. Our apartments offer modern amenities and a state-of-the-art fitness center in a prime North Chesterfield location.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent near me with fitness center provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Stay active in our state-of-the-art fitness center, relax by the pool, or unwind in the clubhouse. Located in North Chesterfield near Richmond, Boulders Lakeside offers easy access to the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Boulders Lakeside. Enjoy modern amenities, a state-of-the-art fitness center, and a prime location in North Chesterfield near Richmond.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-clubhouse",
      "search_query": "Apartments For Rent Near Me with Clubhouse",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Clubhouse",
      "h2_subtitle": "Experience community living at Boulders Lakeside. Our apartments offer modern amenities and a welcoming clubhouse in a prime North Chesterfield location.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent near me with clubhouse provide the perfect blend of comfort and community. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Unwind in our welcoming clubhouse, stay active in the fitness center, or relax by the pool. Located in North Chesterfield near Richmond, Boulders Lakeside offers easy access to the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent Near Me with Clubhouse",
      "seo_description": "Find apartments for rent near me with clubhouse at Boulders Lakeside. Enjoy modern amenities, a welcoming clubhouse, and a prime location in North Chesterfield near Richmond.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-lounge",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Lounge",
      "h2_subtitle": "Relax and socialize at Boulders Lakeside. Our apartments offer modern amenities and a stylish lounge in a prime North Chesterfield location.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent near me with lounge provide the perfect blend of comfort and community. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Unwind in our stylish lounge, stay active in the fitness center, or relax by the pool. Located in North Chesterfield near Richmond, Boulders Lakeside offers easy access to the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent Near Me with Lounge",
      "seo_description": "Find apartments for rent near me with lounge at Boulders Lakeside. Enjoy modern amenities, a stylish lounge, and a prime location in North Chesterfield near Richmond.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-walk-in-closets",
      "search_query": "Apartments For Rent Near Me with Walk-In Closets",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Walk-In Closets",
      "h2_subtitle": "Discover spacious living at Boulders Lakeside. Our apartments offer modern amenities and walk-in closets in a prime North Chesterfield location.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent near me with walk-in closets provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Take advantage of the ample storage space provided by our walk-in closets, relax by the fireplace, or enjoy the views from your patio. Located in North Chesterfield near Richmond, Boulders Lakeside offers easy access to the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent Near Me with Walk-In Closets",
      "seo_description": "Find apartments for rent near me with walk-in closets at Boulders Lakeside. Enjoy modern amenities, spacious storage, and a prime location in North Chesterfield near Richmond.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-patio",
      "search_query": "Apartments For Rent Near Me with Patio",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Patio",
      "h2_subtitle": "Relax and unwind at Boulders Lakeside. Our apartments offer modern amenities and private patios in a prime North Chesterfield location.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent near me with patio provide the perfect blend of comfort and outdoor living. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Step out onto your private patio to relax and take in the views, or cozy up by the fireplace. Located in North Chesterfield near Richmond, Boulders Lakeside offers easy access to the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent Near Me with Patio",
      "seo_description": "Find apartments for rent near me with patio at Boulders Lakeside. Enjoy modern amenities, private outdoor spaces, and a prime location in North Chesterfield near Richmond.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-henrico",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Henrico Doctors' Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Henrico Doctors' Hospital",
      "h2_subtitle": "Find your perfect home at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Henrico Doctors' Hospital in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Henrico Doctors' Hospital provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Henrico Doctors' Hospital, Boulders Lakeside offers easy access to high-quality healthcare and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Henrico Doctors' Hospital",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Henrico Doctors' Hospital at Boulders Lakeside. Enjoy modern amenities and a prime location near high-quality healthcare.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-hospital",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Chippenham Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Chippenham Hospital",
      "h2_subtitle": "Discover comfortable living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Chippenham Hospital in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Chippenham Hospital provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Chippenham Hospital, Boulders Lakeside offers easy access to award-winning medical care and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Chippenham Hospital",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Chippenham Hospital at Boulders Lakeside. Enjoy modern amenities and a prime location near top medical care.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-bon-secours",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Bon Secours St. Mary's Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Bon Secours St. Mary's Hospital",
      "h2_subtitle": "Find your ideal home at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Bon Secours St. Mary's Hospital in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Bon Secours St. Mary's Hospital provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Bon Secours St. Mary's Hospital, Boulders Lakeside offers easy access to high-quality healthcare and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Bon Secours St. Mary's Hospital",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Bon Secours St. Mary's Hospital at Boulders Lakeside. Enjoy modern amenities and a prime location near top medical care.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-cynthia-schieck",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Ms. Cynthia Schieck",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Ms. Cynthia Schieck",
      "h2_subtitle": "Find your perfect home at Boulders Lakeside. Our apartments offer modern amenities and a prime location in North Chesterfield near Ms. Cynthia Schieck.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Ms. Cynthia Schieck provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Ms. Cynthia Schieck, Boulders Lakeside offers easy access to the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Ms. Cynthia Schieck",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Ms. Cynthia Schieck at Boulders Lakeside. Enjoy modern amenities and a prime location near top attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-university-richmond",
      "search_query": "Apartments For Rent In North Chesterfield VA Near University of Richmond",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near University of Richmond",
      "h2_subtitle": "Experience convenient living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near the University of Richmond in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near University of Richmond provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near the University of Richmond, Boulders Lakeside offers easy access to educational opportunities and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near University of Richmond",
      "seo_description": "Find apartments for rent in North Chesterfield VA near University of Richmond at Boulders Lakeside. Enjoy modern amenities and a prime location near top educational institutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-vuu",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Virginia Union University",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Virginia Union University",
      "h2_subtitle": "Discover ideal living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Virginia Union University in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Virginia Union University provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Virginia Union University, Boulders Lakeside offers easy access to educational opportunities and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Virginia Union University",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Virginia Union University at Boulders Lakeside. Enjoy modern amenities and a prime location near top educational institutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-brightpoint-college",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Brightpoint Community College - Midlothian Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Brightpoint Community College - Midlothian Campus",
      "h2_subtitle": "Discover ideal living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Brightpoint Community College - Midlothian Campus in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Brightpoint Community College - Midlothian Campus provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Brightpoint Community College - Midlothian Campus, Boulders Lakeside offers easy access to high-quality educational opportunities and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Brightpoint Community College - Midlothian Campus",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Brightpoint Community College - Midlothian Campus at Boulders Lakeside. Enjoy modern amenities and a prime location near top educational institutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-reynolds-college",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Reynolds Community College",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Reynolds Community College",
      "h2_subtitle": "Experience convenient living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Reynolds Community College in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Reynolds Community College provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Reynolds Community College, Boulders Lakeside offers easy access to high-quality educational opportunities and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Reynolds Community College",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Reynolds Community College at Boulders Lakeside. Enjoy modern amenities and a prime location near top educational institutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-collegiate-school",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Collegiate School",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Collegiate School",
      "h2_subtitle": "Discover ideal living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Collegiate School in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Collegiate School provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Collegiate School, Boulders Lakeside offers easy access to high-quality educational opportunities and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Collegiate School",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Collegiate School at Boulders Lakeside. Enjoy modern amenities and a prime location near top educational institutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-linwood",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Linwood Holton Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Linwood Holton Elementary School",
      "h2_subtitle": "Experience convenient living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Linwood Holton Elementary School in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Linwood Holton Elementary School provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Linwood Holton Elementary School, Boulders Lakeside offers easy access to high-quality educational opportunities and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Linwood Holton Elementary School",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Linwood Holton Elementary School at Boulders Lakeside. Enjoy modern amenities and a prime location near top educational institutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "apartments-for-rent-north-chesterfield-va-near-greenfield",
      "search_query": "Apartments For Rent In North Chesterfield VA Near Greenfield Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In North Chesterfield VA Near Greenfield Elementary School",
      "h2_subtitle": "Discover ideal living at Boulders Lakeside. Our apartments offer modern amenities and a prime location near Greenfield Elementary School in North Chesterfield.",
      "page_copy": "Welcome to Boulders Lakeside, where our apartments for rent in North Chesterfield VA near Greenfield Elementary School provide the perfect blend of comfort and convenience. Our pet-friendly community features 1 & 2 bedroom floor plans with open layouts, premium finishes, and spacious kitchens. Enjoy modern amenities like Wi-Fi, in-unit washer/dryer, and stainless steel appliances. Relax by the fireplace, take in the views from your patio, or stay active in our fitness center. Located near Greenfield Elementary School, Boulders Lakeside offers easy access to high-quality educational opportunities and the best of the area. This is living. This is home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Apartments For Rent In North Chesterfield VA Near Greenfield Elementary School",
      "seo_description": "Find apartments for rent in North Chesterfield VA near Greenfield Elementary School at Boulders Lakeside. Enjoy modern amenities and a prime location near top educational institutions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5722559043600384",
      "source": "custom",
      "page_item_url": "discover-pet-friendly-apartments-north-chesterfield-va",
      "search_query": "Pet-Friendly Apartments in North Chesterfield VA Near Downtown Richmond VA",
      "category": "Pet-Friendly",
      "h1_title": "Discover Pet-Friendly Apartments in North Chesterfield VA Near Downtown Richmond VA",
      "h2_subtitle": "Boulders Lakeside offers a welcoming community for you and your pets. Enjoy spacious living with top amenities in a prime location near downtown Richmond.",
      "page_copy": "Welcome to Boulders Lakeside, where pet-friendly apartments in North Chesterfield VA near downtown Richmond VA await you. Our community features spacious 1 and 2-bedroom floor plans designed to accommodate your lifestyle and your furry friends. Located at 1006 Boulder Lake Drive, our apartments provide easy access to the vibrant city life of Richmond while offering a serene lakeside retreat.\n\nAt Boulders Lakeside, we understand the importance of a pet-friendly environment. Our community is equipped with amenities that cater to both you and your pets, ensuring a comfortable and enjoyable living experience. Whether you're taking a stroll around the lake or relaxing in your spacious apartment, you'll find that Boulders Lakeside is the perfect place to call home. Experience the best of both worlds with our convenient location and pet-friendly atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a building with stone accents.",
        "public_id": "019f6c0c-a7b7-73e9-9bff-7b5a010a69ee",
        "storage_key": "property/5722559043600384/019f6c0c-a7b7-73e9-9bff-7b5a010a69ee.webp",
        "width": 1920,
        "height": 1056
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and large windows.",
        "public_id": "019f6c0c-b072-713a-8683-59021eee0872",
        "storage_key": "property/5722559043600384/019f6c0c-b072-713a-8683-59021eee0872.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Boulders Lakeside | Pet-Friendly Apartments in North Chesterfield VA Near Downtown Richmond VA",
      "seo_description": "Explore Boulders Lakeside's pet-friendly apartments in North Chesterfield VA near downtown Richmond VA. Spacious floor plans and top amenities await you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2144"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471234"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a19\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a19\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5610296"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NCSSB3R"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443201068"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "2911f193202b4281"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/zdqw9y40vo9"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ec853c87-3df3-4ac7-b7d8-a60db2a49b5b"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "804-492-0974"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkJzRFFVSVNUVkwzdjhmR1dKSG1HYUE9PSIsInZhbHVlIjoiVDFEMS9xMDBsY25GTjdiNXpFdGNPUT09IiwibWFjIjoiNDViZGUxOWI4YTZhMzI5ZDVlMzdlM2IwMDMyMGU5ZjJhZWFkMWY4MjAxZDcwOTk1ZmE0MzRhNWEwZTMwZDJhMiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2144",
  "custom_repli_id": "2376471234",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a19\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a19\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5610296",
  "custom_google_gtm_id": "GTM-NCSSB3R",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443201068",
  "custom_knock_community_id": "2911f193202b4281",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/zdqw9y40vo9",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ec853c87-3df3-4ac7-b7d8-a60db2a49b5b",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "804-492-0974",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkJzRFFVSVNUVkwzdjhmR1dKSG1HYUE9PSIsInZhbHVlIjoiVDFEMS9xMDBsY25GTjdiNXpFdGNPUT09IiwibWFjIjoiNDViZGUxOWI4YTZhMzI5ZDVlMzdlM2IwMDMyMGU5ZjJhZWFkMWY4MjAxZDcwOTk1ZmE0MzRhNWEwZTMwZDJhMiJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:40:58.151Z';
